

































































































































































import { Vue, Component } from 'vue-property-decorator';
import { JsonServiceClient, toFormData } from '@servicestack/client';
import WizardMenu from '../WizardMenu.vue';
import ContactInfo from './ContactInfo.vue';
import FundingInfo from './FundingInfo.vue';
import ResearchInfo from './ProtocolInfo.vue';
import Documentation from './DocumentUpload.vue';
import StudySubmission from './StudySubmission.vue';
import { redirect, Routes } from '../../shared/router';
import { bus, store, client, getUserInfo } from '../../shared';
import {
  StudyApplication,
  StudyMiscDoc,
  GrantBase,
  Grants,
  StudyProgress,
  DegreeSelection,
  ReferralSelection,
} from '../../shared/study';
import { UserInfo } from '../../shared/user';
import _ from 'lodash';
@Component({
  components: {
    WizardMenu,
    ContactInfo,
    FundingInfo,
    ResearchInfo,
    Documentation,
    StudySubmission,
  },
})
export default class Study extends Vue {
  /* ------------- Data -------------------- */
  $v: any;
  $bvToast: any;
  file: any = {};
  asyncState: null;
  resetFile: boolean = false;
  activeSession: any = {};
  hasContactComplete: boolean = false;
  hasStudyDetailsComplete: boolean = false;
  hasResearchArea: boolean = false;
  hasAnimalResearch: any = null;
  hasIACUCNumber: any = null;
  hasIsletInterest: any = null;
  hasAcinarInterest: any = null;
  hasFrozenInterest: any = null;
  hasHistoInterest: any = null;
  hasBloodProdInterest: any = null;
  hasAncillaryInterest: any = null;
  hasPeerRevFunding: any = null;
  hasFundsAva: any = null;
  hasNonProfit: any = null;
  hasBloodProd: boolean = false;
  hasBloodProducts: boolean = false;
  hasAncillary: boolean = false;
  hasAncillaryProducts: boolean = false;
  hasFunding: boolean = false;
  hasSupportingDocuments: boolean = false;
  // hasService: boolean = false;
  hasCellPhoneInfo: boolean = false;
  hasValidORCID: boolean = false;
  isApplyingPilot: boolean = false;
  isEligible: boolean = false;
  progress: any = {};
  iidpIsletStudyDashboard: any = '';
  iidpDataStudyDashboard: any = '';
  isHydrated: boolean = false;
  hasReferralMeeting: boolean = false;
  form: any = {
    userId: '',
    appId: 0,
    firstName: '',
    lastName: '',
    middleInitial: null,
    pI_Email: '',
    institution: '',
    study_Title: null,
    projAbstract: null,
    researchMethods: null,
    culturedIslets: false,
    isletsReqReason: null,
    frozenIslets: false,
    rationaleAcinar: null,
    rationaleFrozen: null,
    histoSlides: false,
    rationaleHistoSlides: null,
    rationaleBlood: null,
    rationaleAncillary: null,
    acinar: false,
    bloodProd: false,
    serum: false,
    plasma: false,
    ancillary: false,
    lymphNode: false,
    spleen: false,
    duodenum: false,
    ductal: false,
    frozenPancreaticPcs: false,
    pilot: false,
    iAIPrevApproved: false,
    isletsFunded: false,
    positionGrantAutoElig: false,
    non_Profit: false,
    peer_Rev_Grant: false,
    fundsAva: false,
    title: null,
    pI_Phone: null,
    pI_Phone_Ext: null,
    textMsg: false,
    pI_Cell: null,
    provider_ID: null,
    pI_Address_1: null,
    pI_Address_2: null,
    pI_City: null,
    country: null,
    pI_Zip: null,
    pI_State: null,
    pI_State_Oth: null,
    pI_Province: null,
    time_Zone: null,
    timeZoneOther: null,
    wKShipment: false,
    sameasMailing: false,
    wksameasMailing: false,
    shipCountry: null,
    ship_Addr_1: null,
    ship_Addr_2: null,
    ship_City: null,
    ship_State: null,
    ship_Province: null,
    ship_State_Oth: null,
    ship_Zip: null,
    wK_Contact: null,
    wkShipCountry: null,
    wK_Ship_Addr_1: null,
    wK_Ship_Addr_2: null,
    wK_Ship_City: null,
    wK_Ship_State: null,
    wK_Ship_Province: null,
    wK_Ship_State_Oth: null,
    wK_Ship_Zip: null,
    wK_Phone: null,
    listScientists: null,
    pIconsulted: false,
    pIagreement: false,
    consulted: false,
    policies: false,
    allNonProfit: false,
    coPIReason: null,
    iacuC_Status: null,
    iacuC_App_No: null,
    iacuC_App_Dt: null,
    cellStimulus: false,
    cellDeath: false,
    type1Diabetes: false,
    tissueEngineering: false,
    alphaCells: false,
    geneticsGenomics: false,
    otherArea: false,
    otherAreaText: null,
    comp_Dt: null,
    ieQs_Ideal: '',
    ieQs_Min: '',
    purity_Ideal: '',
    purity_Min: '',
    viability_Ideal: '',
    viability_Min: '',
    freq_Ideal: '',
    freq_Min: '',
    tot_IEQs_Needed: '',
    cultured_Ideal: '',
    cultured_Min: '',
    diabetic_Ideal: '',
    diabetic_Min: '',
    meetingSpecify: null,
    hasORCID: false,
    rsnNoORCID: null,
    orcid: null,
    cultureLen: false,
    cultureMinDay: '',
    cultureMinHr: '',
    cultureMaxDay: '',
    cultureMaxHr: '',
    typeofStudy: '',
    moved: false,
    personId: '',
    animalResearch: null,
    urn: null,
    referralOther: '',
    meeting: '',
    meetingOther: '',
  };
  record: any = {};
  grantList: GrantBase[] = [];
  steps: any = ['ContactInfo', 'FundingInfo', 'ResearchInfo', 'Documentation'];
  menuItems: any = [
    {
      id: 1,
      title: 'Contact & Shipping Information',
      subTitle: 'Weekday/Weekend Shipping Information',
      isValid: false,
    },
    {
      id: 2,
      title: 'Funding ',
      subTitle: 'Funding resources and support for this study',
      isValid: false,
    },
    {
      id: 3,
      title: 'Study Interest & Details ',
      subTitle: 'Research Information & Islet/Biospecimen Requirements',
      isValid: false,
    },
    {
      id: 4,
      title: 'Documents & Submission ',
      subTitle: 'Program Information & Document Upload',
      isValid: false,
    },
  ];
  currentStepNumber: number = 1;
  /* ------------- Props ------------------- */
  get currentStep() {
    return this.steps[this.currentStepNumber - 1];
  }
  processMenuSelection(id: number) {
    this.currentStepNumber = id;
    this.save();
  }

  get length() {
    return this.steps.length;
  }
  get validateSteps() {
    return (
      this.menuItems[0].isValid &&
      this.menuItems[1].isValid &&
      this.menuItems[2].isValid &&
      this.menuItems[3].isValid
    );
  }
  get userSession() {
    return store.userSession;
  }

  goBack() {
    this.currentStepNumber--;
  }
  goNext() {
    this.currentStepNumber++;
  }
  updateAsyncState(state: any) {
    this.asyncState = state;
  }

  onReferralMeetingChanged(value: boolean) {
    this.hasReferralMeeting = value;
    this.processStudyRationaleProgress();
  }
  onResearchAreaChanged(value: boolean) {
    this.hasResearchArea = value;
    this.processStudyRationaleProgress();
  }
  onAnimalResearchChanged(value: boolean) {
    this.hasAnimalResearch = value;
    this.processStudyRationaleProgress();
  }
  onIACUCNumberChanged(value: boolean) {
    this.hasIACUCNumber = value;
    this.processStudyRationaleProgress();
  }
  onIsletInterestChanged(value: boolean) {
    this.hasIsletInterest = value;
    this.processStudyRationaleProgress();
  }
  onHistoChanged(value: boolean) {
    this.hasHistoInterest = value;
    this.processStudyRationaleProgress();
  }
  onAcinarChanged(value: boolean) {
    this.hasAcinarInterest = value;
    this.processStudyRationaleProgress();
  }
  onFrozenChanged(value: boolean) {
    this.hasFrozenInterest = value;
    this.processStudyRationaleProgress();
  }
  onBloodProdChanged(value: boolean) {
    this.hasBloodProdInterest = value;
    this.processStudyRationaleProgress();
  }
  onAncillaryChanged(value: boolean) {
    this.hasAncillaryInterest = value;
    this.processStudyRationaleProgress();
  }
  onPeerRevChanged(value: boolean) {
    this.hasPeerRevFunding = value;
    //   this.processFundingProgress();
  }
  onFundsAvaChanged(value: boolean) {
    this.hasFundsAva = value;
    //   this.processFundingProgress();
  }
  onNonProfitChanged(value: boolean) {
    this.hasNonProfit = value;
    //   this.processFundingProgress();
  }
  onFundingInformationChanged(value: boolean) {
    this.hasFunding = value;
    this.processFundingProgress();
    this.processStepProgress();
  }
  onSupportingDocumentsChanged(value: boolean) {
    this.hasSupportingDocuments = value;
    this.processDocumentProgress();
  }
  // onServiceChanged(value: boolean) {
  //    this.hasService = value;
  // }
  onPilotChanged(value: boolean) {
    this.isApplyingPilot = value;
  }
  // onEligibilityChanged(value: boolean) {
  //    if (this.isApplyingPilot) {
  //        this.isEligible = value;
  //    }
  // }

  onTextMsgChanged(value: boolean) {
    this.hasCellPhoneInfo = value;
    this.processContactInfo();
  }
  async performSave() {
    if (this.hasPeerRevFunding !== null) {
      this.form.peer_Rev_Grant = this.hasPeerRevFunding;
    }
    if (this.hasFundsAva !== null) {
      this.form.fundsAva = this.hasFundsAva;
    }
    if (this.hasNonProfit !== null) {
      this.form.non_Profit = this.hasNonProfit;
    }
    if (this.hasIsletInterest !== null) {
      this.form.culturedIslets = this.hasIsletInterest;
    }
    if (this.hasAcinarInterest !== null) {
      this.form.acinar = this.hasAcinarInterest;
    }
    if (this.hasFrozenInterest !== null) {
      this.form.frozenIslets = this.hasFrozenInterest;
    }
    if (this.hasHistoInterest !== null) {
      this.form.histoSlides = this.hasHistoInterest;
    }

    const r = await client.post(
      new StudyApplication({
        appId: this.form.appId,
        pilot: this.form.pilot,
        iAIPrevApproved: this.form.iAIPrevApproved,
        isletsFunded: this.form.isletsFunded,
        positionGrantAutoElig: this.form.positionGrantAutoElig,
        non_Profit: this.form.non_Profit,
        peer_Rev_Grant: this.form.peer_Rev_Grant,
        fundsAva: this.form.fundsAva,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        middleInitial: this.form.middleInitial,
        pI_Email: this.form.pI_Email,
        institution: this.form.institution,
        title: this.form.title,
        pI_Phone: this.form.pI_Phone,
        pI_Phone_Ext: this.form.pI_Phone_Ext,
        textMsg: this.form.textMsg,
        pI_Cell: this.form.pI_Cell,
        provider_ID: this.form.provider_ID,
        pI_Address_1: this.form.pI_Address_1,
        pI_Address_2: this.form.pI_Address_2,
        pI_City: this.form.pI_City,
        country: this.form.country,
        pI_Zip: this.form.pI_Zip,
        pI_State: this.form.pI_State,
        pI_State_Oth: this.form.pI_State_Oth,
        pI_Province: this.form.pI_Province,
        time_Zone: this.form.time_Zone,
        timeZoneOther: this.form.timeZoneOther,
        wKShipment: this.form.wKShipment,
        sameasMailing: this.form.sameasMailing,
        wksameasMailing: this.form.wksameasMailing,
        shipCountry: this.form.shipCountry,
        ship_Addr_1: this.form.ship_Addr_1,
        ship_Addr_2: this.form.ship_Addr_2,
        ship_City: this.form.ship_City,
        ship_State: this.form.ship_State,
        ship_Province: this.form.ship_Province,
        ship_State_Oth: this.form.ship_State_Oth,
        ship_Zip: this.form.ship_Zip,
        wK_Contact: this.form.wK_Contact,
        wkShipCountry: this.form.wkShipCountry,
        wK_Ship_Addr_1: this.form.wK_Ship_Addr_1,
        wK_Ship_Addr_2: this.form.wK_Ship_Addr_2,
        wK_Ship_City: this.form.wK_Ship_City,
        wK_Ship_State: this.form.wK_Ship_State,
        wK_Ship_Province: this.form.wK_Ship_Province,
        wK_Ship_State_Oth: this.form.wK_Ship_State_Oth,
        wK_Ship_Zip: this.form.wK_Ship_Zip,
        wK_Phone: this.form.wK_Phone,
        listScientists: this.form.listScientists,
        pIconsulted: this.form.pIconsulted,
        pIagreement: this.form.pIagreement,
        consulted: this.form.consulted,
        policies: this.form.policies,
        allNonProfit: this.form.allNonProfit,
        coPIReason: this.form.coPIReason,
        study_Title: this.form.study_Title,
        projAbstract: this.form.projAbstract,
        isletsReqReason: this.form.isletsReqReason,
        researchMethods: this.form.researchMethods,
        rationaleHistoSlides: this.form.rationaleHistoSlides,
        rationaleFrozen: this.form.rationaleFrozen,
        rationaleAcinar: this.form.rationaleAcinar,
        rationaleBlood: this.form.rationaleBlood,
        rationaleAncillary: this.form.rationaleAncillary,
        iacuC_Status: this.form.iacuC_Status,
        iacuC_App_No: this.form.iacuC_App_No,
        iacuC_App_Dt: this.form.iacuC_App_Dt,
        cellStimulus: this.form.cellStimulus,
        cellDeath: this.form.cellDeath,
        type1Diabetes: this.form.type1Diabetes,
        tissueEngineering: this.form.tissueEngineering,
        alphaCells: this.form.alphaCells,
        geneticsGenomics: this.form.geneticsGenomics,
        otherArea: this.form.otherArea,
        otherAreaText: this.form.otherAreaText,
        comp_Dt: this.form.comp_Dt,
        ieQs_Ideal: this.form.ieQs_Ideal,
        ieQs_Min: this.form.ieQs_Min,
        purity_Ideal: this.form.purity_Ideal,
        purity_Min: this.form.purity_Min,
        viability_Ideal: this.form.viability_Ideal,
        viability_Min: this.form.viability_Min,
        freq_Ideal: this.form.freq_Ideal,
        freq_Min: this.form.freq_Min,
        tot_IEQs_Needed: this.form.tot_IEQs_Needed,
        cultured_Ideal: this.form.cultured_Ideal,
        cultured_Min: this.form.cultured_Min,
        diabetic_Ideal: this.form.diabetic_Ideal,
        diabetic_Min: this.form.diabetic_Min,
        culturedIslets: this.form.culturedIslets,
        frozenIslets: this.form.frozenIslets,
        histoSlides: this.form.histoSlides,
        acinar: this.form.acinar,
        bloodProd: this.form.bloodProd,
        serum: this.form.serum,
        plasma: this.form.plasma,
        ancillary: this.form.ancillary,
        lymphNode: this.form.lymphNode,
        spleen: this.form.spleen,
        duodenum: this.form.duodenum,
        ductal: this.form.ductal,
        frozenPancreaticPcs: this.form.frozenPancreaticPcs,
        hasORCID: this.form.hasORCID,
        rsnNoORCID: this.form.rsnNoORCID,
        orcid: this.form.orcid,
        cultureLen: this.form.cultureLen,
        cultureMinDay: this.form.cultureMinDay,
        cultureMinHr: this.form.cultureMinHr,
        cultureMaxDay: this.form.cultureMaxDay,
        cultureMaxHr: this.form.cultureMaxHr,
        moved: this.form.moved,
        submit: this.form.submit,
        typeofStudy: this.form.typeofStudy,
        personId: this.form.personId,
        animalResearch: this.form.animalResearch,
        sessionID: this.form.sessionID,
        urn: this.form.urn,
      }),
    );
    Object.assign(this.form, r.result);

    setTimeout(() => {
      this.addStudyProgress();
      this.processInvestigatorDegrees();
      this.processInvestigatorReferrals();
      getUserInfo();
      this.$bvToast.toast(`Record successfully saved.`, {
        title: 'Save Result',
        variant: 'info',
        autoHideDelay: 2000,
      });
    }, 2000);
  }
  async performSaveStep() {
    if (this.hasPeerRevFunding !== null) {
      this.form.peer_Rev_Grant = this.hasPeerRevFunding;
    }
    if (this.hasFundsAva !== null) {
      this.form.fundsAva = this.hasFundsAva;
    }
    if (this.hasNonProfit !== null) {
      this.form.non_Profit = this.hasNonProfit;
    }

    if (this.hasIsletInterest !== null) {
      this.form.culturedIslets = this.hasIsletInterest;
    }
    if (this.hasAcinarInterest !== null) {
      this.form.acinar = this.hasAcinarInterest;
    }
    if (this.hasFrozenInterest !== null) {
      this.form.frozenIslets = this.hasFrozenInterest;
    }
    if (this.hasHistoInterest !== null) {
      this.form.histoSlides = this.hasHistoInterest;
    }

    const r = await client.post(
      new StudyApplication({
        appId: this.form.appId,
        pilot: this.form.pilot,
        iAIPrevApproved: this.form.iAIPrevApproved,
        isletsFunded: this.form.isletsFunded,
        positionGrantAutoElig: this.form.positionGrantAutoElig,
        non_Profit: this.form.non_Profit,
        peer_Rev_Grant: this.form.peer_Rev_Grant,
        fundsAva: this.form.fundsAva,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        middleInitial: this.form.middleInitial,
        pI_Email: this.form.pI_Email,
        institution: this.form.institution,
        title: this.form.title,
        pI_Phone: this.form.pI_Phone,
        pI_Phone_Ext: this.form.pI_Phone_Ext,
        textMsg: this.form.textMsg,
        pI_Cell: this.form.pI_Cell,
        provider_ID: this.form.provider_ID,
        pI_Address_1: this.form.pI_Address_1,
        pI_Address_2: this.form.pI_Address_2,
        pI_City: this.form.pI_City,
        country: this.form.country,
        pI_Zip: this.form.pI_Zip,
        pI_State: this.form.pI_State,
        pI_State_Oth: this.form.pI_State_Oth,
        pI_Province: this.form.pI_Province,
        time_Zone: this.form.time_Zone,
        timeZoneOther: this.form.timeZoneOther,
        wKShipment: this.form.wKShipment,
        sameasMailing: this.form.sameasMailing,
        wksameasMailing: this.form.wksameasMailing,
        shipCountry: this.form.shipCountry,
        ship_Addr_1: this.form.ship_Addr_1,
        ship_Addr_2: this.form.ship_Addr_2,
        ship_City: this.form.ship_City,
        ship_State: this.form.ship_State,
        ship_Province: this.form.ship_Province,
        ship_State_Oth: this.form.ship_State_Oth,
        ship_Zip: this.form.ship_Zip,
        wK_Contact: this.form.wK_Contact,
        wkShipCountry: this.form.wkShipCountry,
        wK_Ship_Addr_1: this.form.wK_Ship_Addr_1,
        wK_Ship_Addr_2: this.form.wK_Ship_Addr_2,
        wK_Ship_City: this.form.wK_Ship_City,
        wK_Ship_State: this.form.wK_Ship_State,
        wK_Ship_Province: this.form.wK_Ship_Province,
        wK_Ship_State_Oth: this.form.wK_Ship_State_Oth,
        wK_Ship_Zip: this.form.wK_Ship_Zip,
        wK_Phone: this.form.wK_Phone,
        listScientists: this.form.listScientists,
        pIconsulted: this.form.pIconsulted,
        pIagreement: this.form.pIagreement,
        consulted: this.form.consulted,
        policies: this.form.policies,
        allNonProfit: this.form.allNonProfit,
        coPIReason: this.form.coPIReason,
        study_Title: this.form.study_Title,
        projAbstract: this.form.projAbstract,
        isletsReqReason: this.form.isletsReqReason,
        researchMethods: this.form.researchMethods,
        rationaleHistoSlides: this.form.rationaleHistoSlides,
        rationaleFrozen: this.form.rationaleFrozen,
        rationaleAcinar: this.form.rationaleAcinar,
        rationaleBlood: this.form.rationaleBlood,
        rationaleAncillary: this.form.rationaleAncillary,
        iacuC_Status: this.form.iacuC_Status,
        iacuC_App_No: this.form.iacuC_App_No,
        iacuC_App_Dt: this.form.iacuC_App_Dt,
        cellStimulus: this.form.cellStimulus,
        cellDeath: this.form.cellDeath,
        type1Diabetes: this.form.type1Diabetes,
        tissueEngineering: this.form.tissueEngineering,
        alphaCells: this.form.alphaCells,
        geneticsGenomics: this.form.geneticsGenomics,
        otherArea: this.form.otherArea,
        otherAreaText: this.form.otherAreaText,
        comp_Dt: this.form.comp_Dt,
        ieQs_Ideal: this.form.ieQs_Ideal,
        ieQs_Min: this.form.ieQs_Min,
        purity_Ideal: this.form.purity_Ideal,
        purity_Min: this.form.purity_Min,
        viability_Ideal: this.form.viability_Ideal,
        viability_Min: this.form.viability_Min,
        freq_Ideal: this.form.freq_Ideal,
        freq_Min: this.form.freq_Min,
        tot_IEQs_Needed: this.form.tot_IEQs_Needed,
        cultured_Ideal: this.form.cultured_Ideal,
        cultured_Min: this.form.cultured_Min,
        diabetic_Ideal: this.form.diabetic_Ideal,
        diabetic_Min: this.form.diabetic_Min,
        culturedIslets: this.form.culturedIslets,
        frozenIslets: this.form.frozenIslets,
        histoSlides: this.form.histoSlides,
        acinar: this.form.acinar,
        bloodProd: this.form.bloodProd,
        serum: this.form.serum,
        plasma: this.form.plasma,
        ancillary: this.form.ancillary,
        lymphNode: this.form.lymphNode,
        spleen: this.form.spleen,
        duodenum: this.form.duodenum,
        ductal: this.form.ductal,
        frozenPancreaticPcs: this.form.frozenPancreaticPcs,
        hasORCID: this.form.hasORCID,
        rsnNoORCID: this.form.rsnNoORCID,
        orcid: this.form.orcid,
        cultureLen: this.form.cultureLen,
        cultureMinDay: this.form.cultureMinDay,
        cultureMinHr: this.form.cultureMinHr,
        cultureMaxDay: this.form.cultureMaxDay,
        cultureMaxHr: this.form.cultureMaxHr,
        moved: this.form.moved,
        submit: this.form.submit,
        typeofStudy: this.form.typeofStudy,
        personId: this.form.personId,
        animalResearch: this.form.animalResearch,
        urn: this.form.urn,
      }),
    );
    Object.assign(this.form, r.result);
    setTimeout(() => {
      this.addStudyProgress();
      this.processInvestigatorDegrees();
      this.processInvestigatorReferrals();
      getUserInfo();
    }, 1000);
  }
  async performSubmit() {
    if (this.hasPeerRevFunding !== null) {
      this.form.peer_Rev_Grant = this.hasPeerRevFunding;
    }
    if (this.hasFundsAva !== null) {
      this.form.fundsAva = this.hasFundsAva;
    }
    if (this.hasNonProfit !== null) {
      this.form.non_Profit = this.hasNonProfit;
    }
    if (this.hasIsletInterest !== null) {
      this.form.culturedIslets = this.hasIsletInterest;
    }
    if (this.hasAcinarInterest !== null) {
      this.form.acinar = this.hasAcinarInterest;
    }
    if (this.hasFrozenInterest !== null) {
      this.form.frozenIslets = this.hasFrozenInterest;
    }
    if (this.hasHistoInterest !== null) {
      this.form.histoSlides = this.hasHistoInterest;
    }
    const r = await client.post(
      new StudyApplication({
        appId: this.form.appId,
        pilot: this.form.pilot,
        iAIPrevApproved: this.form.iAIPrevApproved,
        isletsFunded: this.form.isletsFunded,
        positionGrantAutoElig: this.form.positionGrantAutoElig,
        non_Profit: this.form.non_Profit,
        peer_Rev_Grant: this.form.peer_Rev_Grant,
        fundsAva: this.form.fundsAva,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        middleInitial: this.form.middleInitial,
        pI_Email: this.form.pI_Email,
        institution: this.form.institution,
        title: this.form.title,
        pI_Phone: this.form.pI_Phone,
        pI_Phone_Ext: this.form.pI_Phone_Ext,
        textMsg: this.form.textMsg,
        pI_Cell: this.form.pI_Cell,
        provider_ID: this.form.provider_ID,
        pI_Address_1: this.form.pI_Address_1,
        pI_Address_2: this.form.pI_Address_2,
        pI_City: this.form.pI_City,
        country: this.form.country,
        pI_Zip: this.form.pI_Zip,
        pI_State: this.form.pI_State,
        pI_State_Oth: this.form.pI_State_Oth,
        pI_Province: this.form.pI_Province,
        time_Zone: this.form.time_Zone,
        timeZoneOther: this.form.timeZoneOther,
        wKShipment: this.form.wKShipment,
        sameasMailing: this.form.sameasMailing,
        wksameasMailing: this.form.wksameasMailing,
        shipCountry: this.form.shipCountry,
        ship_Addr_1: this.form.ship_Addr_1,
        ship_Addr_2: this.form.ship_Addr_2,
        ship_City: this.form.ship_City,
        ship_State: this.form.ship_State,
        ship_Province: this.form.ship_Province,
        ship_State_Oth: this.form.ship_State_Oth,
        ship_Zip: this.form.ship_Zip,
        wK_Contact: this.form.wK_Contact,
        wkShipCountry: this.form.wkShipCountry,
        wK_Ship_Addr_1: this.form.wK_Ship_Addr_1,
        wK_Ship_Addr_2: this.form.wK_Ship_Addr_2,
        wK_Ship_City: this.form.wK_Ship_City,
        wK_Ship_State: this.form.wK_Ship_State,
        wK_Ship_Province: this.form.wK_Ship_Province,
        wK_Ship_State_Oth: this.form.wK_Ship_State_Oth,
        wK_Ship_Zip: this.form.wK_Ship_Zip,
        wK_Phone: this.form.wK_Phone,
        listScientists: this.form.listScientists,
        pIconsulted: this.form.pIconsulted,
        pIagreement: this.form.pIagreement,
        consulted: this.form.consulted,
        policies: this.form.policies,
        allNonProfit: this.form.allNonProfit,
        coPIReason: this.form.coPIReason,
        study_Title: this.form.study_Title,
        projAbstract: this.form.projAbstract,
        isletsReqReason: this.form.isletsReqReason,
        researchMethods: this.form.researchMethods,
        rationaleHistoSlides: this.form.rationaleHistoSlides,
        rationaleFrozen: this.form.rationaleFrozen,
        rationaleAcinar: this.form.rationaleAcinar,
        rationaleBlood: this.form.rationaleBlood,
        rationaleAncillary: this.form.rationaleAncillary,
        iacuC_Status: this.form.iacuC_Status,
        iacuC_App_No: this.form.iacuC_App_No,
        iacuC_App_Dt: this.form.iacuC_App_Dt,
        cellStimulus: this.form.cellStimulus,
        cellDeath: this.form.cellDeath,
        type1Diabetes: this.form.type1Diabetes,
        tissueEngineering: this.form.tissueEngineering,
        alphaCells: this.form.alphaCells,
        geneticsGenomics: this.form.geneticsGenomics,
        otherArea: this.form.otherArea,
        otherAreaText: this.form.otherAreaText,
        comp_Dt: this.form.comp_Dt,
        ieQs_Ideal: this.form.ieQs_Ideal,
        ieQs_Min: this.form.ieQs_Min,
        purity_Ideal: this.form.purity_Ideal,
        purity_Min: this.form.purity_Min,
        viability_Ideal: this.form.viability_Ideal,
        viability_Min: this.form.viability_Min,
        freq_Ideal: this.form.freq_Ideal,
        freq_Min: this.form.freq_Min,
        tot_IEQs_Needed: this.form.tot_IEQs_Needed,
        cultured_Ideal: this.form.cultured_Ideal,
        cultured_Min: this.form.cultured_Min,
        diabetic_Ideal: this.form.diabetic_Ideal,
        diabetic_Min: this.form.diabetic_Min,
        culturedIslets: this.form.culturedIslets,
        frozenIslets: this.form.frozenIslets,
        histoSlides: this.form.histoSlides,
        acinar: this.form.acinar,
        bloodProd: this.form.bloodProd,
        serum: this.form.serum,
        plasma: this.form.plasma,
        ancillary: this.form.ancillary,
        lymphNode: this.form.lymphNode,
        spleen: this.form.spleen,
        duodenum: this.form.duodenum,
        ductal: this.form.ductal,
        frozenPancreaticPcs: this.form.frozenPancreaticPcs,
        hasORCID: this.form.hasORCID,
        rsnNoORCID: this.form.rsnNoORCID,
        orcid: this.form.orcid,
        cultureLen: this.form.cultureLen,
        cultureMinDay: this.form.cultureMinDay,
        cultureMinHr: this.form.cultureMinHr,
        cultureMaxDay: this.form.cultureMaxDay,
        cultureMaxHr: this.form.cultureMaxHr,
        moved: this.form.moved,
        submit: this.form.submit,
        typeofStudy: this.form.typeofStudy,
        personId: this.form.personId,
        animalResearch: this.form.animalResearch,
        urn: this.form.urn,
      }),
    );
    Object.assign(this.form, r.result);
    setTimeout(() => {
      this.addStudyProgress();
      this.processInvestigatorDegrees();
      this.processInvestigatorReferrals();
      getUserInfo();
    }, 1000);
    this.reloadPage();
  }

  async addStudyProgress() {
    const d = await client.post(
      new StudyProgress({ progress: this.menuItems }),
    );
    this.userInfo.study.progress = d.result;
  }

  get userInfo() {
    return store.userInfo;
  }
  mounted() {
    this.loadToForm();
    const iidpSecureUrl = IIDPconfig.SECURE_URL as string;
    this.iidpIsletStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.ISLET_STUDY_DASHBOARD as string}`;
    this.iidpDataStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.DATA_STUDY_DASHBOARD as string}`;
    if (localStorage.getItem('reloaded')) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem('reloaded');
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem('reloaded', '1');
      location.reload();
    }

    this.processProgress();
    this.processDocumentProgress();
  }

  async processInvestigatorDegrees() {
    const d = await client.post(
      new DegreeSelection({
        appId: this.form.appId,
        degreeList: this.form.degrees,
        degreeOther: this.form.degreeOther,
      }),
    );
  }

  async processInvestigatorReferrals() {
    const list = Array.isArray(this.form.referrals)
      ? this.form.referrals.map((x: any) => Number(x))
      : [];
    const r = await client.post(
      new ReferralSelection({
        appId: this.form.appId,
        referralList: list,
        referralOther: this.form.referralOther,
        meeting: this.form.meeting,
        meetingOther: this.form.meetingOther,
      }),
    );
  }

  submit() {
    if (this.validateSteps) {
      this.confirmSubmission();
    }
  }
  async confirmSubmission() {
    // if case the user selected a file and did not click save, upload the file first ONLY if the file is selected...
    this.$swal({
      title: ' Study Application Validator',
      text: 'Preparing data for submission...',
      icon: 'info',
      showCancelButton: false,
      showConfirmButton: false,
    });
    // add a wait timing buffer for file upload
    setTimeout(() => {
      getUserInfo();
      // make sure the data submission has a supporting document
      // alert the user if theres no supporting document, otherwise, proceed with the submission
      if (store.userInfo.study.docs.length < 2) {
        this.$swal({
          title: ' Study Application Validator',
          text:
            'Supporting documents are missing. Please attach the required documentaion before submission.',
        });
        this.menuItems[3].isValid = false;
      } else if (
        (store.userInfo.study.form.frozenIslets &&
          store.userInfo.study.form.rationaleFrozen === '') ||
        (store.userInfo.study.form.culturedIslets &&
          store.userInfo.study.form.isletsReqReason === '') ||
        (store.userInfo.study.form.acinar &&
          store.userInfo.study.form.rationaleAcinar === '') ||
        (store.userInfo.study.form.histoSlides &&
          store.userInfo.study.form.rationaleHistoSlides === '') ||
        (store.userInfo.study.form.bloodProd &&
          store.userInfo.study.form.rationaleBlood === '') ||
        (store.userInfo.study.form.ancillary &&
          store.userInfo.study.form.rationaleAncillary === '')
      ) {
        this.$swal({
          title: ' Study Application Validator',
          text:
            'You selected an interest for your study, but have not entered a rationale. Please return to Step 3 and complete the form. ',
        });
        this.menuItems[2].isValid = false;
      } else if (
        !store.userInfo.study.form.culturedIslets &&
        !store.userInfo.study.form.frozenIslets &&
        !store.userInfo.study.form.acinar &&
        !store.userInfo.study.form.histoSlides &&
        !store.userInfo.study.form.bloodProd &&
        !store.userInfo.study.form.ancillary
      ) {
        this.$swal({
          title: ' Study Application Validator',
          text:
            'You have not selected a study interest. Please return to Step 3 and complete the form. ',
        });
        this.menuItems[2].isValid = false;
      } else {
        this.$swal({
          title: ' Study Application Submission',
          text:
            'You are about to submit your study application. Do you wish to proceed?',
          icon: 'warning',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-info m-1',
            cancelButton: 'btn btn-secondary m-1',
          },
          confirmButtonText: 'Yes, submit my application!',
          html: false,
          preConfirm: () => {
            return new Promise((resolve: any) => {
              setTimeout(() => {
                resolve();
              }, 50);
            });
          },
        }).then(async (result: any) => {
          if (result.value) {
            this.$swal(
              'Submitted',
              'Your  study application has been submitted.',
              'success',
            );
            this.form.submit = true;
            this.performSubmit();
            this.form.moved = true;
          } else if (result.dismiss === 'cancel') {
            this.performSave();
            this.$swal(
              'Cancelled',
              'Your submission will be cancelled.',
              'error',
            );
          }
        });
      }
    }, 500);
  }
  reloadPage() {
    window.location.reload();
  }
  save() {
    if (this.userInfo.userInfo) {
      if (this.form.firstName === '') {
        this.form.firstName = this.userInfo.userInfo.firstName;
      }
      if (this.form.lastName === '') {
        this.form.lastName = this.userInfo.userInfo.lastName;
      }
      if (this.form.institution === '') {
        this.form.institution = this.userInfo.userInfo.institution;
      }
      if (this.form.pI_Email === '') {
        this.form.pI_Email = this.userInfo.userInfo.email;
      }
      this.saveProgress();
      this.performSaveStep();
      this.processInvestigatorDegrees();
      this.processInvestigatorReferrals();
      this.$bvToast.toast(`Record successfully saved.`, {
        title: 'Save Result',
        variant: 'info',
        autoHideDelay: 1000,
      });
    }
  }
  loadToForm() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.study.form);
      Object.assign(this.form, payload.study.referralList);
      this.form.referrals = this.userInfo.study.referralList;
      this.form.referralOther = this.userInfo.study.referralOther;
      this.form.meeting = this.userInfo.study.meeting;
      this.form.meetingOther = this.userInfo.study.meetingOther;
      this.activeSession = JSON.parse(
        localStorage.getItem(this.userInfo.userInfo.userName) || '{}',
      );
      if (!_.isEmpty(this.activeSession)) {
        this.form.firstName = this.activeSession.firstName;
        this.form.lastName = this.activeSession.lastName;
        this.form.pI_Email = this.activeSession.email.slice(6);
        this.form.institution = this.activeSession.institution;
        this.form.pI_Address_1 = this.activeSession.addressline1;
        this.form.pI_Address_2 = this.activeSession.addressline2;
        this.form.pI_City = this.activeSession.city;
        this.form.pI_State = this.activeSession.state;
        if (this.activeSession.country !== undefined) {
          this.form.country = this.activeSession.country;
        }
        this.form.pI_State_Oth = this.activeSession.stateOther;
        this.form.pI_Province = this.activeSession.province;
        this.form.pI_Zip = this.activeSession.zip;
        this.form.pI_Phone = this.activeSession.phone;
        this.form.pI_Phone_Ext = this.activeSession.phoneExt;
        this.form.personId = this.activeSession.personId;
        this.form.hasORCID = this.activeSession.hasORCID;
        this.form.rsnNoORCID = this.activeSession.rsnNoORCID;
        this.form.orcid = this.activeSession.orcid;
        this.form.title = this.activeSession.title;
        if (this.activeSession.timezone === '0') {
          this.form.time_Zone = '';
        } else {
          this.form.time_Zone = this.activeSession.timezone;
        }
        this.form.timeZoneOther = this.activeSession.timeZoneOther;
        this.form.role = this.activeSession.role;
        this.form.appId = this.activeSession.rowId;
      }
      this.processProgress();
    });
  }

    async created() {
        if (Object.keys(this.userInfo).length === 0) {
            const u = this.userSession!.userName;
            if (u !== undefined && u !== null) {
                const d = await client.get(new UserInfo({ userName: u }));
                bus.$set(store, 'userInfo', d);
                bus.$emit('userInfo', d);
        if (!_.isEmpty(this.activeSession)) {
          this.form.firstName = this.activeSession.firstName;
          this.form.lastName = this.activeSession.lastName;
          this.form.middleInitial = this.activeSession.middleInitial;
          this.form.pI_Email = this.activeSession.email.slice(6);
          this.form.institution = this.activeSession.institution;
          this.form.pI_Address_1 = this.activeSession.addressline1;
          this.form.pI_Address_2 = this.activeSession.addressline2;
          this.form.pI_City = this.activeSession.city;
          this.form.pI_State = this.activeSession.state;
          if (this.activeSession.country !== undefined) {
            this.form.country = this.activeSession.country;
          }
          this.form.pI_State_Oth = this.activeSession.stateOther;
          this.form.pI_Province = this.activeSession.province;
          this.form.pI_Zip = this.activeSession.zip;
          this.form.pI_Phone = this.activeSession.phone;
          this.form.pI_Phone_Ext = this.activeSession.phoneExt;
          this.form.personId = this.activeSession.personId;
          this.form.hasORCID = this.activeSession.hasORCID;
          this.form.rsnNoORCID = this.activeSession.rsnNoORCID;
          this.form.orcid = this.activeSession.orcid;
          this.form.title = this.activeSession.title;
          this.form.time_Zone = this.activeSession.timezone;
          this.form.timeZoneOther = this.activeSession.timeZoneOther;
          this.form.role = this.activeSession.role;
          this.form.appId = this.activeSession.rowId;
          Object.assign(
            this.activeSession,
            Object.values(this.userInfo.study.form),
          );
          Object.assign(
            this.progress,
            Object.values(this.userInfo.study.progress),
          );
          this.processProgress();
        }
      }
    }
    if (this.userInfo.study && this.userInfo.study.form) {
      Object.assign(this.form, this.userInfo.study.form);
    }
  }
  private processFundingProgress() {
    if (
      this.userInfo !== undefined &&
      this.userInfo.study !== undefined &&
      this.userInfo.study.progress !== undefined
    ) {
      for (let i = 0; i < this.userInfo.study.progress.length; i++) {
        for (let j = 0; j < this.menuItems.length; j++) {
          if (this.menuItems[j].id === this.userInfo.study.progress[i].id) {
            this.menuItems[j].isValid = this.userInfo.study.progress[i].status;
            this.menuItems[j].appID = this.userInfo.study.form.appId;
            this.menuItems[j].userId = this.userInfo.study.form.userId;
            setTimeout(() => {
              if (
                (this.form.peer_Rev_Grant ||
                  this.form.fundsAva ||
                  this.form.non_Profit) &&
                this.userInfo.study.grantList.length >= 1
              ) {
                this.menuItems[1].isValid = true;
                this.performSaveStep();
              } else {
                this.menuItems[1].isValid = false;
                this.performSaveStep();
              }
            }, 100);
            this.saveProgress();

            break;
          }
        }
      }
    }
  }
  private processContactInfo() {
    if (
      this.userInfo !== undefined &&
      this.userInfo.study !== undefined &&
      this.userInfo.study.progress !== undefined
    ) {
      for (let i = 0; i < this.userInfo.study.progress.length; i++) {
        for (let j = 0; j < this.menuItems.length; j++) {
          if (this.menuItems[j].id === this.userInfo.study.progress[i].id) {
            this.menuItems[j].isValid = this.userInfo.study.progress[i].status;
            this.menuItems[j].appID = this.userInfo.study.form.appId;
            this.menuItems[j].userId = this.userInfo.study.form.userId;
            setTimeout(() => {
              if (
                this.hasCellPhoneInfo &&
                this.form.pI_Cell !== null &&
                this.form.provider_ID !== null
              ) {
                //
              } else {
                this.menuItems[0].isValid = false;
                this.performSaveStep();
              }
            }, 3000);
            this.saveProgress();
            break;
          }
        }
      }
    }
  }
  private processDocumentProgress() {
    if (
      this.userInfo !== undefined &&
      this.userInfo.study !== undefined &&
      this.userInfo.study.progress !== undefined
    ) {
      for (let i = 0; i < this.userInfo.study.progress.length; i++) {
        for (let j = 0; j < this.menuItems.length; j++) {
          if (this.menuItems[j].id === this.userInfo.study.progress[i].id) {
            this.menuItems[j].isValid = this.userInfo.study.progress[i].status;
            this.menuItems[j].appID = this.userInfo.study.form.appId;
            this.menuItems[j].userId = this.userInfo.study.form.userId;
            setTimeout(() => {
              if (this.userInfo.study.docs.length > 1) {
                this.menuItems[3].isValid = true;
              } else {
                this.menuItems[3].isValid = false;
              }
            }, 3000);
            this.saveProgress();
            break;
          }
        }
      }
    }
  }
  private processStudyRationaleProgress() {
    if (
      this.userInfo !== undefined &&
      this.userInfo.study !== undefined &&
      this.userInfo.study.progress !== undefined
    ) {
      for (let i = 0; i < this.userInfo.study.progress.length; i++) {
        for (let j = 0; j < this.menuItems.length; j++) {
          if (this.menuItems[j].id === this.userInfo.study.progress[i].id) {
            this.menuItems[j].isValid = this.userInfo.study.progress[i].status;
            this.menuItems[j].appID = this.userInfo.study.form.appId;
            this.menuItems[j].userId = this.userInfo.study.form.userId;
            setTimeout(() => {
              if (
                (!this.hasAcinarInterest &&
                  !this.hasFrozenInterest &&
                  !this.hasIsletInterest &&
                  !this.hasHistoInterest &&
                  !this.hasAncillaryInterest &&
                  !this.hasBloodProdInterest) ||
                (this.userInfo.study.form.culturedIslets &&
                  (this.userInfo.study.form.comp_Dt === undefined ||
                    this.userInfo.study.form.comp_Dt === '' ||
                    this.userInfo.study.form.ieQs_Ideal === undefined ||
                    this.userInfo.study.form.ieQs_Ideal === '' ||
                    this.userInfo.study.form.ieQs_Min === undefined ||
                    this.userInfo.study.form.ieQs_Min === '' ||
                    this.userInfo.study.form.purity_Ideal === undefined ||
                    this.userInfo.study.form.purity_Ideal === '' ||
                    this.userInfo.study.form.purity_Min === undefined ||
                    this.userInfo.study.form.purity_Min === '' ||
                    this.userInfo.study.form.viability_Ideal === undefined ||
                    this.userInfo.study.form.viability_Ideal === '' ||
                    this.userInfo.study.form.viability_Min === undefined ||
                    this.userInfo.study.form.viability_Min === '' ||
                    this.userInfo.study.form.freq_Ideal === undefined ||
                    this.userInfo.study.form.freq_Ideal === '' ||
                    this.userInfo.study.form.freq_Min === undefined ||
                    this.userInfo.study.form.freq_Min === '' ||
                    this.userInfo.study.form.tot_IEQs_Needed === undefined ||
                    this.userInfo.study.form.tot_IEQs_Needed === '' ||
                    (this.userInfo.study.form.pilot &&
                      this.userInfo.study.form.tot_IEQs_Needed > 100000) ||
                    this.userInfo.study.form.cultured_Ideal === undefined ||
                    this.userInfo.study.form.cultured_Ideal === '' ||
                    this.userInfo.study.form.cultured_Min === undefined ||
                    this.userInfo.study.form.cultured_Min === '' ||
                    this.userInfo.study.form.diabetic_Ideal === undefined ||
                    this.userInfo.study.form.diabetic_Ideal === '' ||
                    this.userInfo.study.form.diabetic_Min === undefined ||
                    this.userInfo.study.form.diabetic_Min === '' ||
                    this.userInfo.study.form.diabetic_Ideal === undefined ||
                    this.userInfo.study.form.diabetic_Ideal === '')) ||
                (!this.userInfo.study.form.cellDeath &&
                  !this.userInfo.study.form.cellStimulus &&
                  !this.userInfo.study.form.type1Diabetes &&
                  !this.userInfo.study.form.tissueEngineering &&
                  !this.userInfo.study.form.alphaCells &&
                  !this.userInfo.study.form.geneticsGenomics &&
                  !this.userInfo.study.form.otherArea) ||
                (this.userInfo.study.form.otherArea &&
                  (this.userInfo.study.form.otherAreaText === '' ||
                    this.userInfo.study.form.otherAreaText === undefined ||
                    this.userInfo.study.form.otherAreaText === null)) ||
                this.userInfo.study.form.animalResearch === null ||
                (this.userInfo.study.form.animalResearch &&
                  this.userInfo.study.form.iacuC_Status === null) ||
                (this.userInfo.study.form.iacuC_Status === '1' &&
                  (!this.hasIACUCNumber ||
                    this.userInfo.study.form.iacuC_App_No === null ||
                    this.userInfo.study.form.IACUC_App_Dt === null)) ||
                (this.userInfo.study.form.cultureLen &&
                  (isNaN(parseInt(this.userInfo.study.form.cultureMinDay, 10))
                    ? 0
                    : 24 *
                      parseInt(this.userInfo.study.form.cultureMinDay, 10)) +
                    (isNaN(parseInt(this.userInfo.study.form.cultureMinHr, 10))
                      ? 0
                      : parseInt(this.userInfo.study.form.cultureMinHr, 10)) >
                    (isNaN(parseInt(this.userInfo.study.form.cultureMaxDay, 10))
                      ? 0
                      : 24 *
                        parseInt(this.userInfo.study.form.cultureMaxDay, 10)) +
                      (isNaN(
                        parseInt(this.userInfo.study.form.cultureMaxHr, 10),
                      )
                        ? 0
                        : parseInt(
                            this.userInfo.study.form.cultureMaxHr,
                            10,
                          ))) ||
                (isNaN(parseInt(this.userInfo.study.form.cultureMinDay, 10))
                  ? 0
                  : 24 * parseInt(this.userInfo.study.form.cultureMinDay, 10)) +
                  (isNaN(parseInt(this.userInfo.study.form.cultureMinHr, 10))
                    ? 0
                    : parseInt(this.userInfo.study.form.cultureMinHr, 10)) ===
                  0 ||
                (isNaN(parseInt(this.userInfo.study.form.cultureMaxDay, 10))
                  ? 0
                  : 24 * parseInt(this.userInfo.study.form.cultureMaxDay, 10)) +
                  (isNaN(parseInt(this.userInfo.study.form.cultureMaxHr, 10))
                    ? 0
                    : parseInt(this.userInfo.study.form.cultureMaxHr, 10)) ===
                  0 ||
                (this.userInfo.study.form.bloodProd &&
                  !this.userInfo.study.form.serum &&
                  !this.userInfo.study.form.plasma) ||
                (this.userInfo.study.form.ancillary &&
                  !this.userInfo.study.form.spleen &&
                  !this.userInfo.study.form.duodenum &&
                  !this.userInfo.study.form.lymphNode)
              ) {
                this.menuItems[2].isValid = false;
                this.performSaveStep();
              } else {
                if (
                  this.form.culturedIslets &&
                  (this.form.isletsReqReason === undefined ||
                    this.form.isletsReqReason === null ||
                    this.form.isletsReqReason === '')
                ) {
                  this.menuItems[2].isValid = false;
                }
                if (
                  this.form.frozenIslets &&
                  this.form.peer_Rev_Grant &&
                  (this.form.rationaleFrozen === undefined ||
                    this.form.rationaleFrozen === null ||
                    this.form.rationaleFrozen === '')
                ) {
                  this.menuItems[2].isValid = false;
                }
                if (
                  this.form.histoSlides &&
                  this.form.peer_Rev_Grant &&
                  (this.form.rationaleHistoSlides === undefined ||
                    this.form.rationaleHistoSlides === null ||
                    this.form.rationaleHistoSlides === '')
                ) {
                  this.menuItems[2].isValid = false;
                }
                if (
                  this.form.acinar &&
                  this.form.peer_Rev_Grant &&
                  (this.form.rationaleAcinar === undefined ||
                    this.form.rationaleAcinar === null ||
                    this.form.rationaleAcinar === '')
                ) {
                  this.menuItems[2].isValid = false;
                }
                if (
                  this.form.ancillary &&
                  this.form.peer_Rev_Grant &&
                  (this.form.rationaleAncillary === undefined ||
                    this.form.rationaleAncillary === null ||
                    this.form.rationaleAncillary === '')
                ) {
                  this.menuItems[2].isValid = false;
                }
                if (
                  this.form.bloodProd &&
                  this.form.peer_Rev_Grant &&
                  (this.form.rationaleBlood === undefined ||
                    this.form.rationaleBlood === null ||
                    this.form.rationaleBlood === '')
                ) {
                  this.menuItems[2].isValid = false;
                }
                this.menuItems[2].isValid = true;
                this.performSaveStep();
              }
            }, 500);
            this.saveProgress();
            break;
          }
        }
      }
    }
  }

  private processProgress() {
    if (
      this.userInfo !== undefined &&
      this.userInfo.study !== undefined &&
      this.userInfo.study.progress !== undefined
    ) {
      for (let i = 0; i < this.userInfo.study.progress.length; i++) {
        for (let j = 0; j < this.menuItems.length; j++) {
          if (this.menuItems[j].id === this.userInfo.study.progress[i].id) {
            this.menuItems[j].isValid = this.userInfo.study.progress[i].status;
            this.menuItems[j].appID = this.userInfo.study.form.appId;
            this.menuItems[j].userId = this.userInfo.study.form.userId;
            const validationPhoneRegex = /^[ ]*(?:\+?(\d{1,5}))*[-. )]?(\d+)?[-. (]?([2-9]\d{2})*[-. )]*?(\d{2})*[-. )]*(\d{3,4})*[-. ]*(\d{4,20})[ ]*$/;
            if (
              this.userInfo.study.form.firstName === null ||
              this.userInfo.study.form.firstName === '' ||
              this.userInfo.study.form.firstName === undefined ||
              this.userInfo.study.form.lastName === null ||
              this.userInfo.study.form.lastName === '' ||
              this.userInfo.study.form.lastName === undefined ||
              this.userInfo.study.form.pI_Email === null ||
              this.userInfo.study.form.pI_Email === '' ||
              this.userInfo.study.form.pI_Email === undefined ||
              this.userInfo.study.form.institution === null ||
              this.userInfo.study.form.institution === '' ||
              this.userInfo.study.form.institution === undefined ||
              this.userInfo.study.form.title === null ||
              this.userInfo.study.form.title === '' ||
              this.userInfo.study.form.title === undefined ||
              this.userInfo.study.form.pI_Address_1 === null ||
              this.userInfo.study.form.pI_Address_1 === '' ||
              this.userInfo.study.form.pI_Address_1 === undefined ||
              this.userInfo.study.form.pI_City === null ||
              this.userInfo.study.form.pI_City === '' ||
              this.userInfo.study.form.pI_City === undefined ||
              this.userInfo.study.form.pI_Zip === null ||
              this.userInfo.study.form.pI_Zip === '' ||
              this.userInfo.study.form.pI_Zip === undefined ||
              (((this.userInfo.study.form.country === 'United States' &&
                this.userInfo.study.form.pI_State === '') ||
                this.userInfo.study.form.pI_State === null ||
                this.userInfo.study.form.pI_State === undefined) &&
                (this.userInfo.study.form.country === 'Germany' ||
                  this.userInfo.study.form.country === 'Australia' ||
                  (this.userInfo.study.form.country === 'Israel' &&
                    (this.userInfo.study.form.pI_State_Oth === null ||
                      this.userInfo.study.form.pI_State_Oth === '' ||
                      this.userInfo.study.form.pI_State_Oth === undefined)))) ||
              (this.userInfo.study.form.country === 'Canada' &&
                this.userInfo.study.form.pI_Province === null) ||
              this.userInfo.study.form.pI_Province === '' ||
              this.userInfo.study.form.pI_Province === undefined ||
              this.userInfo.study.form.country === null ||
              this.userInfo.study.form.country === '' ||
              this.userInfo.study.form.country === undefined ||
              this.userInfo.study.form.pI_Phone === null ||
              this.userInfo.study.form.pI_Phone === '' ||
              this.userInfo.study.form.pI_Phone === '(111) 111-1111' ||
              this.userInfo.study.form.pI_Phone === undefined ||
              this.userInfo.study.form.time_Zone === null ||
              this.userInfo.study.form.time_Zone === '' ||
              this.userInfo.study.form.time_Zone === undefined ||
              (this.userInfo.study.form.wKShipment &&
                (this.userInfo.study.form.wkShipCountry === '' ||
                  this.userInfo.study.form.wkShipCountry === null ||
                  this.userInfo.study.form.wkShipCountry === undefined ||
                  this.userInfo.study.form.wK_Ship_Addr_1 === '' ||
                  this.userInfo.study.form.wK_Ship_Addr_1 === null ||
                  this.userInfo.study.form.wK_Ship_Addr_1 === undefined ||
                  this.userInfo.study.form.wK_Ship_City === '' ||
                  this.userInfo.study.form.wK_Ship_City === null ||
                  this.userInfo.study.form.wK_Ship_City === undefined ||
                  (this.userInfo.study.form.wK_Ship_State === null &&
                    this.userInfo.study.form.wK_Ship_State_Oth === null &&
                    this.userInfo.study.form.wK_Ship_Province === null) ||
                  this.userInfo.study.form.wK_Ship_Zip === '' ||
                  this.userInfo.study.form.wK_Ship_Zip === null ||
                  this.userInfo.study.form.wK_Ship_Zip === undefined)) ||
              (this.userInfo.study.form.sameasMailing &&
                (this.userInfo.study.form.shipCountry === '' ||
                  this.userInfo.study.form.shipCountry === null ||
                  this.userInfo.study.form.shipCountry === undefined ||
                  this.userInfo.study.form.ship_Addr_1 === '' ||
                  this.userInfo.study.form.ship_Addr_1 === null ||
                  this.userInfo.study.form.ship_Addr_1 === undefined ||
                  this.userInfo.study.form.ship_City === '' ||
                  this.userInfo.study.form.ship_City === null ||
                  this.userInfo.study.form.ship_City === undefined ||
                  (this.userInfo.study.form.ship_State === null &&
                    this.userInfo.study.form.ship_State_Oth === null &&
                    this.userInfo.study.form.ship_Province === null) ||
                  this.userInfo.study.form.ship_Zip === '' ||
                  this.userInfo.study.form.ship_Zip === null ||
                  this.userInfo.study.form.ship_Zip === undefined)) ||
              (this.userInfo.study.degreeList.length < 1 &&
                this.form.degrees.length < 1) ||
              (!this.userInfo.study.form.hasORCID &&
                this.userInfo.study.form.rsnNoORCID === null) ||
              this.userInfo.study.form.rsnNoORCID === '' ||
              (this.userInfo.study.form.hasORCID &&
                this.userInfo.study.form.orcid === null) ||
              this.userInfo.study.form.orcid === '' ||
              (this.userInfo.study.form.hasORCID &&
                this.userInfo.study.form.orcid !== null &&
                this.userInfo.study.form.orcid.indexOf('_') !== -1) ||
              (this.userInfo.study.form.textMsg &&
                (this.userInfo.study.form.pI_Cell === null ||
                  this.userInfo.study.form.pI_Cell === ''))
            ) {
              if (this.hasContactComplete) {
                this.menuItems[0].isValid = true;
              } else {
                this.menuItems[0].isValid = false;
              }
            } else {
              if (this.hasContactComplete) {
                this.menuItems[0].isValid = true;
              } else {
                this.menuItems[0].isValid = false;
              }
            }
            if (
              this.userInfo.study.form.peer_Rev_Grant ||
              this.userInfo.study.form.fundsAva ||
              this.userInfo.study.form.non_Profit
            ) {
              if (this.userInfo.study.grantList.length > 0) {
                this.menuItems[1].isValid = true;
              } else {
                this.menuItems[1].isValid = false;
              }
            } else {
              this.menuItems[1].isValid = false;
            }
            if (this.userInfo.study.docs.length > 1) {
              this.menuItems[3].isValid = true;
            } else {
              this.menuItems[3].isValid = false;
            }

            if (
              this.form.study_Title === '' ||
              this.form.study_Title === null ||
              this.form.projAbstract === '' ||
              this.form.projAbstract === null ||
              this.form.researchMethods === '' ||
              this.form.researchMethods === null ||
              this.userInfo.study.form.comp_Dt === undefined ||
              this.userInfo.study.form.comp_Dt === '' ||
              this.userInfo.study.referralList === undefined ||
              this.userInfo.study.referralList === null ||
              ((this.userInfo.study.referralList !== undefined ||
                this.userInfo.study.referralList !== null) &&
                this.userInfo.study.referralList.indexOf('4') !== -1 &&
                (this.userInfo.study.meeting === 0 ||
                  this.userInfo.study.meeting === null)) ||
              (!this.userInfo.study.form.culturedIslets &&
                !this.userInfo.study.form.histoSlides &&
                !this.userInfo.study.form.frozenIslets &&
                !this.userInfo.study.form.acinar) ||
              (this.userInfo.study.form.culturedIslets &&
                (this.userInfo.study.form.ieQs_Ideal === undefined ||
                  this.userInfo.study.form.ieQs_Ideal === '' ||
                  this.userInfo.study.form.ieQs_Min === undefined ||
                  this.userInfo.study.form.ieQs_Min === '' ||
                  this.userInfo.study.form.purity_Ideal === undefined ||
                  this.userInfo.study.form.purity_Ideal === '' ||
                  this.userInfo.study.form.purity_Min === undefined ||
                  this.userInfo.study.form.purity_Min === '' ||
                  this.userInfo.study.form.viability_Ideal === undefined ||
                  this.userInfo.study.form.viability_Ideal === '' ||
                  this.userInfo.study.form.viability_Min === undefined ||
                  this.userInfo.study.form.viability_Min === '' ||
                  this.userInfo.study.form.freq_Ideal === undefined ||
                  this.userInfo.study.form.freq_Ideal === '' ||
                  this.userInfo.study.form.freq_Min === undefined ||
                  this.userInfo.study.form.freq_Min === '' ||
                  this.userInfo.study.form.tot_IEQs_Needed === undefined ||
                  this.userInfo.study.form.tot_IEQs_Needed === '' ||
                  (this.userInfo.study.form.pilot &&
                    this.userInfo.study.form.tot_IEQs_Needed > 100000) ||
                  this.userInfo.study.form.cultured_Ideal === undefined ||
                  this.userInfo.study.form.cultured_Ideal === '' ||
                  this.userInfo.study.form.cultured_Min === undefined ||
                  this.userInfo.study.form.cultured_Min === '' ||
                  this.userInfo.study.form.diabetic_Ideal === undefined ||
                  this.userInfo.study.form.diabetic_Ideal === '' ||
                  this.userInfo.study.form.diabetic_Min === undefined ||
                  this.userInfo.study.form.diabetic_Min === '' ||
                  this.userInfo.study.form.diabetic_Ideal === undefined ||
                  this.userInfo.study.form.diabetic_Ideal === '')) ||
              (!this.userInfo.study.form.cellDeath &&
                !this.userInfo.study.form.cellStimulus &&
                !this.userInfo.study.form.type1Diabetes &&
                !this.userInfo.study.form.tissueEngineering &&
                !this.userInfo.study.form.alphaCells &&
                !this.userInfo.study.form.geneticsGenomics &&
                !this.userInfo.study.form.otherArea) ||
              (this.userInfo.study.form.cultureLen &&
                (isNaN(parseInt(this.userInfo.study.form.cultureMinDay, 10))
                  ? 0
                  : 24 * parseInt(this.userInfo.study.form.cultureMinDay, 10)) +
                  (isNaN(parseInt(this.userInfo.study.form.cultureMinHr, 10))
                    ? 0
                    : parseInt(this.userInfo.study.form.cultureMinHr, 10)) >
                  (isNaN(parseInt(this.userInfo.study.form.cultureMaxDay, 10))
                    ? 0
                    : 24 *
                      parseInt(this.userInfo.study.form.cultureMaxDay, 10)) +
                    (isNaN(parseInt(this.userInfo.study.form.cultureMaxHr, 10))
                      ? 0
                      : parseInt(this.userInfo.study.form.cultureMaxHr, 10))) ||
              (isNaN(parseInt(this.userInfo.study.form.cultureMinDay, 10))
                ? 0
                : 24 * parseInt(this.userInfo.study.form.cultureMinDay, 10)) +
                (isNaN(parseInt(this.userInfo.study.form.cultureMinHr, 10))
                  ? 0
                  : parseInt(this.userInfo.study.form.cultureMinHr, 10)) ===
                0 ||
              (isNaN(parseInt(this.userInfo.study.form.cultureMaxDay, 10))
                ? 0
                : 24 * parseInt(this.userInfo.study.form.cultureMaxDay, 10)) +
                (isNaN(parseInt(this.userInfo.study.form.cultureMaxHr, 10))
                  ? 0
                  : parseInt(this.userInfo.study.form.cultureMaxHr, 10)) ===
                0 ||
              (this.userInfo.study.form.bloodProd &&
                !this.userInfo.study.form.serum &&
                !this.userInfo.study.form.plasma) ||
              (this.userInfo.study.form.ancillary &&
                !this.userInfo.study.form.spleen &&
                !this.userInfo.study.form.duodenum &&
                !this.userInfo.study.form.lymphNode) ||
              this.userInfo.study.form.animalResearch === null ||
              (this.userInfo.study.form.animalResearch &&
                (this.userInfo.study.form.iacuC_Status === null ||
                  this.userInfo.study.form.iacuC_Status === '' ||
                  this.userInfo.study.form.iacuC_Status === undefined)) ||
              (this.userInfo.study.form.iacuC_Status === 1 &&
                (this.userInfo.study.form.iacuC_App_No === null ||
                  this.userInfo.study.form.iacuC_App_No === '' ||
                  this.userInfo.study.form.iacuC_App_Dt === null))
            ) {
              this.menuItems[2].isValid = false;
            } else {
              this.menuItems[2].isValid = true;
              if (
                this.userInfo.study.form.culturedIslets &&
                !this.userInfo.study.form.peer_Rev_Grant &&
                (this.userInfo.study.form.isletsReqReason === undefined ||
                  this.userInfo.study.form.isletsReqReason === null ||
                  this.userInfo.study.form.isletsReqReason === '')
              ) {
                this.menuItems[2].isValid = false;
              }
              if (
                this.userInfo.study.form.frozenIslets &&
                !this.userInfo.study.form.peer_Rev_Grant &&
                (this.userInfo.study.form.rationaleFrozen === undefined ||
                  this.userInfo.study.form.rationaleFrozen === null ||
                  this.userInfo.study.form.rationaleFrozen === '')
              ) {
                this.menuItems[2].isValid = false;
              }
              if (
                this.userInfo.study.form.histoSlides &&
                !this.userInfo.study.form.peer_Rev_Grant &&
                (this.userInfo.study.form.rationaleHistoSlides === undefined ||
                  this.userInfo.study.form.rationaleHistoSlides === null ||
                  this.userInfo.study.form.rationaleHistoSlides === '')
              ) {
                this.menuItems[2].isValid = false;
              }
              if (
                this.userInfo.study.form.acinar &&
                !this.userInfo.study.form.peer_Rev_Grant &&
                (this.userInfo.study.form.rationaleAcinar === undefined ||
                  this.userInfo.study.form.rationaleAcinar === null ||
                  this.userInfo.study.form.rationaleAcinar === '')
              ) {
                this.menuItems[2].isValid = false;
              }
              if (
                this.userInfo.study.form.ancillary &&
                !this.userInfo.study.form.peer_Rev_Grant &&
                (this.userInfo.study.form.rationaleAncillary === undefined ||
                  this.userInfo.study.form.rationaleAncillary === null ||
                  this.userInfo.study.form.rationaleAncillary === '')
              ) {
                this.menuItems[2].isValid = false;
              }
              if (
                this.userInfo.study.form.bloodProd &&
                this.userInfo.study.form.peer_Rev_Grant &&
                (this.userInfo.study.form.rationaleBlood === undefined ||
                  this.userInfo.study.form.rationaleBlood === null ||
                  this.userInfo.study.form.rationaleBlood === '')
              ) {
                this.menuItems[2].isValid = false;
              }
            }
          }
          this.saveProgress();
          break;
        }
      }
    }
  }

  private processStepProgress() {
    setTimeout(() => {
      if (this.form !== undefined && this.form !== '' && this.form !== null) {
        for (let i = 0; i < this.userInfo.study.progress.length; i++) {
          for (let j = 0; j < this.menuItems.length; j++) {
            if (this.menuItems[j].id === this.userInfo.study.progress[i].id) {
              this.menuItems[j].isValid = this.userInfo.study.progress[
                i
              ].status;
              this.menuItems[j].appID = this.userInfo.study.form.appId;
              this.menuItems[j].userId = this.userInfo.study.form.userId;
              const validationPhoneRegex = /^[ ]*(?:\+?(\d{1,5}))*[-. )]?(\d+)?[-. (]?([2-9]\d{2})*[-. )]*?(\d{2})*[-. )]*(\d{3,4})*[-. ]*(\d{4,20})[ ]*$/;
              if (
                this.form.firstName === null ||
                this.form.firstName === '' ||
                this.form.firstName === undefined ||
                this.form.lastName === null ||
                this.form.lastName === '' ||
                this.form.lastName === undefined ||
                this.form.pI_Email === null ||
                this.form.pI_Email === '' ||
                this.form.pI_Email === undefined ||
                this.form.institution === null ||
                this.form.institution === '' ||
                this.form.institution === undefined ||
                this.form.title === null ||
                this.form.title === '' ||
                this.form.title === undefined ||
                this.form.pI_Address_1 === null ||
                this.form.pI_Address_1 === '' ||
                this.form.pI_Address_1 === undefined ||
                this.form.pI_City === null ||
                this.form.pI_City === '' ||
                this.form.pI_City === undefined ||
                this.form.pI_Zip === null ||
                this.form.pI_Zip === '' ||
                this.form.pI_Zip === undefined ||
                (this.form.country === 'United States' &&
                  (this.form.pI_State === '' ||
                    this.form.pI_State === null ||
                    this.form.pI_State === undefined)) ||
                this.form.country === 'Germany' ||
                this.form.country === 'Australia' ||
                (this.form.country === 'Israel' &&
                  (this.form.pI_State_Oth === null ||
                    this.form.pI_State_Oth === '' ||
                    this.form.pI_State_Oth === undefined)) ||
                (this.form.country === 'Canada' &&
                  (this.form.pI_Province === null ||
                    this.form.pI_Province === '' ||
                    this.form.pI_Province === undefined)) ||
                this.form.country === null ||
                this.form.country === '' ||
                this.form.country === undefined ||
                this.form.pI_Phone === null ||
                this.form.pI_Phone === '' ||
                this.form.pI_Phone === '(111) 111-1111' ||
                this.form.pI_Phone === undefined ||
                this.form.time_Zone === null ||
                this.form.time_Zone === '' ||
                this.form.time_Zone === undefined ||
                (this.form.wKShipment &&
                  (this.form.wkShipCountry === '' ||
                    this.form.wkShipCountry === null ||
                    this.form.wkShipCountry === undefined ||
                    this.form.wK_Ship_Addr_1 === '' ||
                    this.form.wK_Ship_Addr_1 === null ||
                    this.form.wK_Ship_Addr_1 === undefined ||
                    this.form.wK_Ship_City === '' ||
                    this.form.wK_Ship_City === null ||
                    this.form.wK_Ship_City === undefined ||
                    (this.form.wK_Ship_State === null &&
                      this.form.wK_Ship_State_Oth === null &&
                      this.form.wK_Ship_Province === null) ||
                    this.form.wK_Ship_Zip === '' ||
                    this.form.wK_Ship_Zip === null ||
                    this.form.wK_Ship_Zip === undefined)) ||
                (this.form.sameasMailing &&
                  (this.form.shipCountry === '' ||
                    this.form.shipCountry === null ||
                    this.form.shipCountry === undefined ||
                    this.form.ship_Addr_1 === '' ||
                    this.form.ship_Addr_1 === null ||
                    this.form.ship_Addr_1 === undefined ||
                    this.form.ship_City === '' ||
                    this.form.ship_City === null ||
                    this.form.ship_City === undefined ||
                    (this.form.ship_State === null &&
                      this.form.ship_State_Oth === null &&
                      this.form.ship_Province === null) ||
                    this.form.ship_Zip === '' ||
                    this.form.ship_Zip === null ||
                    this.form.ship_Zip === undefined)) ||
                (this.userInfo.study.degreeList.length < 1 &&
                  this.form.degrees.length < 1) ||
                (!this.form.hasORCID && this.form.rsnNoORCID === null) ||
                this.form.rsnNoORCID === '' ||
                (this.form.hasORCID && this.form.orcid === null) ||
                this.form.orcid === '' ||
                (this.form.hasORCID &&
                  this.form.orcid !== null &&
                  this.form.orcid.indexOf('_') !== -1) ||
                (this.form.pI_Phone !== null &&
                  this.form.pI_Phone !== '' &&
                  this.form.pI_Phone.match(validationPhoneRegex))
              ) {
                if (this.hasContactComplete) {
                  this.menuItems[0].isValid = true;
                } else {
                  this.menuItems[0].isValid = false;
                }
              } else {
                if (this.hasContactComplete) {
                  this.menuItems[0].isValid = true;
                } else {
                  this.menuItems[0].isValid = false;
                }
              }
              if (
                (this.form.peer_Rev_Grant ||
                  this.form.fundsAva ||
                  this.form.non_Profit) &&
                (this.userInfo.study.grantList.length >= 1 || this.hasFunding)
              ) {
                this.menuItems[1].isValid = true;
              } else {
                this.menuItems[1].isValid = false;
              }
              if (this.userInfo.study.docs.length > 1) {
                this.menuItems[3].isValid = true;
              } else {
                this.menuItems[3].isValid = false;
              }
              if (
                !this.form.study_Title ||
                this.form.study_Title.trim().length < 2 ||
                !this.form.projAbstract ||
                this.form.projAbstract.trim().length < 2 ||
                !this.form.researchMethods ||
                this.form.researchMethods.trim().length < 2 ||
                this.form.comp_Dt === null ||
                this.form.comp_Dt === undefined ||
                this.form.comp_Dt === '' ||
                (!this.form.culturedIslets &&
                  !this.form.histoSlides &&
                  !this.form.frozenIslets &&
                  !this.form.acinar &&
                  !this.form.ancillary &&
                  !this.form.bloodProd) ||
                (this.form.culturedIslets &&
                  (this.form.ieQs_Ideal === undefined ||
                    this.form.ieQs_Ideal === '' ||
                    this.form.ieQs_Min === undefined ||
                    this.form.ieQs_Min === '' ||
                    this.form.purity_Ideal === undefined ||
                    this.form.purity_Ideal === '' ||
                    this.form.purity_Min === undefined ||
                    this.form.purity_Min === '' ||
                    this.form.viability_Ideal === undefined ||
                    this.form.viability_Ideal === '' ||
                    this.form.viability_Min === undefined ||
                    this.form.viability_Min === '' ||
                    this.form.freq_Ideal === undefined ||
                    this.form.freq_Ideal === '' ||
                    this.form.freq_Min === undefined ||
                    this.form.freq_Min === '' ||
                    this.form.tot_IEQs_Needed === undefined ||
                    this.form.tot_IEQs_Needed === '' ||
                    (this.userInfo.study.form.pilot &&
                      this.form.tot_IEQs_Needed > 100000) ||
                    this.form.cultured_Ideal === undefined ||
                    this.form.cultured_Ideal === '' ||
                    this.form.cultured_Min === undefined ||
                    this.form.cultured_Min === '' ||
                    this.form.diabetic_Ideal === undefined ||
                    this.form.diabetic_Ideal === '' ||
                    this.form.diabetic_Min === undefined ||
                    this.form.diabetic_Min === '' ||
                    this.form.diabetic_Ideal === undefined ||
                    this.form.diabetic_Ideal === '')) ||
                (!this.form.cellDeath &&
                  !this.form.cellStimulus &&
                  !this.form.type1Diabetes &&
                  !this.form.tissueEngineering &&
                  !this.form.alphaCells &&
                  !this.form.geneticsGenomics &&
                  !this.form.otherArea) ||
                (this.form.otherArea &&
                  (!this.form.otherAreaText ||
                    this.form.otherAreaText.trim().length < 2)) ||
                (this.form.cultureLen &&
                  ((isNaN(parseInt(this.form.cultureMinDay, 10))
                    ? 0
                    : 24 * parseInt(this.form.cultureMinDay, 10)) +
                    (isNaN(parseInt(this.form.cultureMinHr, 10))
                      ? 0
                      : parseInt(this.form.cultureMinHr, 10)) >
                    (isNaN(parseInt(this.form.cultureMaxDay, 10))
                      ? 0
                      : 24 * parseInt(this.form.cultureMaxDay, 10)) +
                      (isNaN(parseInt(this.form.cultureMaxHr, 10))
                        ? 0
                        : parseInt(this.form.cultureMaxHr, 10)) ||
                    (isNaN(parseInt(this.form.cultureMinDay, 10))
                      ? 0
                      : 24 * parseInt(this.form.cultureMinDay, 10)) +
                      (isNaN(parseInt(this.form.cultureMinHr, 10))
                        ? 0
                        : parseInt(this.form.cultureMinHr, 10)) ===
                      0 ||
                    (isNaN(parseInt(this.form.cultureMaxDay, 10))
                      ? 0
                      : 24 * parseInt(this.form.cultureMaxDay, 10)) +
                      (isNaN(parseInt(this.form.cultureMaxHr, 10))
                        ? 0
                        : parseInt(this.form.cultureMaxHr, 10)) ===
                      0)) ||
                (this.form.bloodProd &&
                  !this.form.serum &&
                  !this.form.plasma) ||
                (this.form.ancillary &&
                  !this.form.spleen &&
                  !this.form.duodenum &&
                  !this.form.lymphNode &&
                  !this.form.frozenPancreaticPcs) ||
                this.form.animalResearch === null ||
                (this.form.animalResearch &&
                  (this.form.iacuC_Status === null ||
                    this.form.iacuC_Status === '' ||
                    this.form.iacuC_Status === undefined)) ||
                (this.form.iacuC_Status === 1 &&
                  (this.form.iacuC_App_No === null ||
                    this.form.iacuC_App_No === '' ||
                    this.form.iacuC_App_Dt === null)) ||
                (this.form.culturedIslets &&
                  !this.form.peer_Rev_Grant &&
                  (!this.form.isletsReqReason ||
                    this.form.isletsReqReason.trim().length < 2)) ||
                (this.form.frozenIslets &&
                  !this.form.peer_Rev_Grant &&
                  (!this.form.rationaleFrozen ||
                    this.form.rationaleFrozen.trim().length < 2)) ||
                (this.form.histoSlides &&
                  !this.form.peer_Rev_Grant &&
                  (!this.form.rationaleHistoSlides ||
                    this.form.rationaleHistoSlides.trim().length < 2)) ||
                (this.form.acinar &&
                  !this.form.peer_Rev_Grant &&
                  (!this.form.rationaleAcinar ||
                    this.form.rationaleAcinar.trim().length < 2)) ||
                (this.form.ancillary &&
                  !this.form.peer_Rev_Grant &&
                  (!this.form.rationaleAncillary ||
                    this.form.rationaleAncillary.trim().length < 2)) ||
                (this.form.bloodProd &&
                  !this.form.peer_Rev_Grant &&
                  (!this.form.rationaleBlood ||
                    this.form.rationaleBlood.trim().length < 2)) ||
                this.form.referrals === undefined ||
                this.form.referrals === null ||
                this.form.referrals.length < 1 ||
                ((this.form.referrals !== null ||
                  this.form.referrals !== undefined) &&
                  this.form.referrals.length > 0 &&
                  this.form.referrals.indexOf(-9) !== -1 &&
                  (this.form.referralOther === '' ||
                    this.form.referralOther === undefined ||
                    this.form.referralOther === null)) ||
                (this.form.referrals.indexOf(4) !== -1 &&
                  (this.form.meeting === null ||
                    this.form.meeting === 0 ||
                    this.form.meeting === undefined ||
                    !this.form.meeting ||
                    this.form.meeting === 'null')) ||
                ((this.form.meeting === -9 || this.form.meeting === '-9') &&
                  (this.form.meetingOther === '' ||
                    this.form.meetingOther === null ||
                    this.form.meetingOther === undefined ||
                    this.form.meetingOther === 'null' ||
                    this.form.meetingOther.trim().length < 2)) ||
                ((this.form.meeting === -9 || this.form.meeting === '-9') &&
                  (this.form.meetingOther === '' ||
                    this.form.meetingOther === null ||
                    this.form.meetingOther === undefined ||
                    this.form.meetingOther === 'null' ||
                    this.form.meetingOther.trim().length < 2))
              ) {
                this.menuItems[2].isValid = false;
              } else {
                this.menuItems[2].isValid = true;
              }
            }
            this.saveProgress();
            break;
          }
        }
      }
    }, 1000);
  }

  private saveProgress() {
    if (
      this.userInfo !== undefined &&
      this.userInfo.study !== undefined &&
      this.userInfo.study.progress !== undefined
    ) {
      for (let i = 0; i < this.userInfo.study.progress.length; i++) {
        for (let j = 0; j < this.menuItems.length; j++) {
          if (this.menuItems[j].id === this.userInfo.study.progress[i].id) {
            this.menuItems[j].status = this.menuItems[j].isValid;
            this.menuItems[j].section = this.menuItems[j].id;
            break;
          }
        }
      }
    }
  }
  private processStep(stepData: any) {
    if (this.userInfo.study.form === undefined) {
      this.save();
    }
    setTimeout(() => {
      this.menuItems[stepData.id - 1].isValid = stepData.isValid;
      Object.assign(this.form, stepData.formData);
      const validationRegex = /^[ ]*(?:\+?(\d{1,5}))*[-. )]?(\d+)?[-. (]?([2-9]\d{2})*[-. )]*?(\d{2})*[-. )]*(\d{3,4})*[-. ]*(\d{4,20})[ ]*$/;
      if (stepData.isValid && this.userInfo.study !== undefined) {
        if (stepData.id === 1) {
          if (
            !this.form.firstName ||
            this.form.firstName.trim().length < 2 ||
            !this.form.lastName ||
            this.form.lastName.trim().length < 2 ||
            this.form.pI_Email === null ||
            this.form.pI_Email === '' ||
            this.form.pI_Email === undefined ||
            !this.form.institution ||
            this.form.institution.trim().length < 2 ||
            !this.form.title ||
            this.form.title.trim().length < 2 ||
            !this.form.pI_Address_1 ||
            this.form.pI_Address_1.trim().length < 2 ||
            !this.form.pI_City ||
            this.form.pI_City.trim().length < 2 ||
            !this.form.pI_Zip ||
            this.form.pI_Zip.trim().length < 2 ||
            (this.form.country === 'United States' &&
              (this.form.pI_State === '' ||
                this.form.pI_State === null ||
                this.form.pI_State === undefined)) ||
            ((this.form.country === 'Germany' ||
              this.form.country === 'Australia' ||
              this.form.country === 'Israel') &&
              (this.form.pI_State_Oth === null ||
                this.form.pI_State_Oth === '' ||
                this.form.pI_State_Oth === undefined)) ||
            (this.form.country === 'Canada' &&
              (this.form.pI_Province === null ||
                this.form.pI_Province === '' ||
                this.form.pI_Province === undefined)) ||
            this.form.country === null ||
            this.form.country === '' ||
            this.form.country === undefined ||
            this.form.pI_Phone === null ||
            this.form.pI_Phone === '' ||
            this.form.pI_Phone === '(111) 111-1111' ||
            this.form.pI_Phone === undefined ||
            this.form.time_Zone === null ||
            this.form.time_Zone === '' ||
            this.form.time_Zone === undefined ||
            (this.form.wKShipment &&
              (this.form.wkShipCountry === '' ||
                this.form.wkShipCountry === null ||
                !this.form.wK_Ship_Addr_1 ||
                this.form.wK_Ship_Addr_1.trim().length < 2 ||
                !this.form.wK_Ship_City ||
                this.form.wK_Ship_City.trim().length < 2 ||
                !this.form.wK_Ship_Zip ||
                this.form.wK_Ship_Zip.trim().length < 2 ||
                (this.form.wkShipCountry === 'United States' &&
                  (this.form.wK_Ship_State === '' ||
                    this.form.wK_Ship_State === null ||
                    this.form.wK_Ship_State === undefined)) ||
                ((this.form.wkShipCountry === 'Germany' ||
                  this.form.wkShipCountry === 'Australia' ||
                  this.form.wkShipCountry === 'Israel') &&
                  (this.form.wK_Ship_State_Oth === null ||
                    this.form.wK_Ship_State_Oth === '' ||
                    this.form.wK_Ship_State_Oth === undefined)) ||
                (this.form.wkShipCountry === 'Canada' &&
                  (this.form.wK_Ship_Province === null ||
                    this.form.wK_Ship_Province === '' ||
                    this.form.wK_Ship_Province === undefined)))) ||
            this.form.shipCountry === '' ||
            this.form.shipCountry === null ||
            this.form.ship_Addr_1 === '' ||
            this.form.ship_Addr_1 === null ||
            this.form.ship_City === '' ||
            this.form.ship_City === null ||
            this.form.ship_Zip === '' ||
            this.form.ship_Zip === null ||
            (this.form.shipCountry === 'United States' &&
              (this.form.ship_State === '' ||
                this.form.ship_State === null ||
                this.form.ship_State === undefined)) ||
            ((this.form.shipCountry === 'Germany' ||
              this.form.shipCountry === 'Australia' ||
              this.form.shipCountry === 'Israel') &&
              (this.form.ship_State_Oth === null ||
                this.form.ship_State_Oth === '' ||
                this.form.ship_State_Oth === undefined)) ||
            (this.form.shipCountry === 'Canada' &&
              (this.form.ship_Province === null ||
                this.form.ship_Province === '' ||
                this.form.ship_Province === undefined)) ||
            this.form.degrees.length < 1 ||
            (this.form.degrees.length > 0 &&
              this.form.degrees.indexOf(-9) !== -1 &&
              (this.form.degreeOther === '' ||
                this.form.degreeOther === undefined)) ||
            (!this.form.hasORCID && this.form.rsnNoORCID === null) ||
            this.form.rsnNoORCID === '' ||
            (this.form.hasORCID && this.form.orcid === null) ||
            this.form.orcid === '' ||
            (this.form.hasORCID &&
              this.form.orcid !== null &&
              this.form.orcid.indexOf('_') !== -1) ||
            (this.form.textMsg &&
              (this.form.pI_Cell === null || this.form.provider_ID === null)) ||
            (this.form.textMsg &&
              this.form.pI_Cell !== null &&
              !this.form.pI_Cell.match(validationRegex)) ||
            (this.form.pI_Phone !== null &&
              !this.form.pI_Phone.match(validationRegex)) ||
            (this.form.pI_Phone !== null &&
              !this.form.pI_Phone.match(validationRegex)) ||
            (this.form.wK_Phone !== null &&
              !this.form.wK_Phone.match(validationRegex))
          ) {
            this.menuItems[0].isValid = false;
            this.hasContactComplete = false;
          } else {
            this.menuItems[0].isValid = true;
            this.hasContactComplete = true;
            if (
              this.form.wKShipment &&
              (this.form.wkShipCountry === '' ||
                this.form.wkShipCountry === null ||
                !this.form.wK_Ship_Addr_1 ||
                this.form.wK_Ship_Addr_1.trim().length < 2 ||
                !this.form.wK_Ship_City ||
                this.form.wK_Ship_City.trim().length < 2 ||
                !this.form.wK_Ship_Zip ||
                this.form.wK_Ship_Zip.trim().length < 2 ||
                (this.form.wkShipCountry === 'United States' &&
                  (this.form.wK_Ship_State === '' ||
                    this.form.wK_Ship_State === null ||
                    this.form.wK_Ship_State === undefined)) ||
                ((this.form.wkShipCountry === 'Germany' ||
                  this.form.wkShipCountry === 'Australia' ||
                  this.form.wkShipCountry === 'Israel') &&
                  (this.form.wK_Ship_State_Oth === null ||
                    this.form.wK_Ship_State_Oth === '' ||
                    this.form.wK_Ship_State_Oth === undefined)) ||
                (this.form.wkShipCountry === 'Canada' &&
                  (this.form.wK_Ship_Province === null ||
                    this.form.wK_Ship_Province === '' ||
                    this.form.wK_Ship_Province === undefined)))
            ) {
              this.menuItems[0].isValid = false;
              this.hasContactComplete = false;
            }
            if (
              this.form.shipCountry === '' ||
              this.form.shipCountry === null ||
              !this.form.ship_Addr_1 ||
              this.form.ship_Addr_1.trim().length < 2 ||
              !this.form.ship_City ||
              this.form.ship_City.trim().length < 2 ||
              !this.form.ship_Zip ||
              this.form.ship_Zip.trim().length < 2 ||
              (this.form.shipCountry === 'United States' &&
                (this.form.ship_State === '' ||
                  this.form.ship_State === null ||
                  this.form.ship_State === undefined)) ||
              ((this.form.shipCountry === 'Germany' ||
                this.form.shipCountry === 'Australia' ||
                this.form.shipCountry === 'Israel') &&
                (this.form.ship_State_Oth === null ||
                  this.form.ship_State_Oth === '' ||
                  this.form.ship_State_Oth === undefined)) ||
              (this.form.shipCountry === 'Canada' &&
                (this.form.ship_Province === null ||
                  this.form.ship_Province === '' ||
                  this.form.ship_Province === undefined))
            ) {
              this.menuItems[0].isValid = false;
              this.hasContactComplete = false;
            }
            if (
              this.form.country !== '' &&
              this.form.country === 'United States' &&
              this.form.country === 'Canada' &&
              this.form.pI_Phone !== null &&
              !this.form.pI_Phone.match(validationRegex)
            ) {
              this.hasContactComplete = false;
              this.menuItems[0].isValid = false;
            }
            if (
              this.form.country !== '' &&
              this.form.country !== 'United States' &&
              this.form.country !== 'Canada' &&
              this.form.pI_Phone === null
            ) {
              this.hasContactComplete = false;
              this.menuItems[0].isValid = false;
            }
          }
          this.processStepProgress();
        }
        if (stepData.id === 2) {
          if (
            (this.form.peer_Rev_Grant ||
              this.form.fundsAva ||
              this.form.non_Profit) &&
            (this.userInfo.study.grantList.length >= 1 || this.hasFunding)
          ) {
            this.menuItems[1].isValid = true;
          } else {
            this.menuItems[1].isValid = false;
          }
          this.processStepProgress();
        }
        if (stepData.id === 3) {
          if (
            !this.form.study_Title ||
            this.form.study_Title.trim().length < 2 ||
            !this.form.projAbstract ||
            this.form.projAbstract.trim().length < 2 ||
            !this.form.researchMethods ||
            this.form.researchMethods.trim().length < 2 ||
            this.form.comp_Dt === null ||
            this.form.comp_Dt === undefined ||
            this.form.comp_Dt === '' ||
            (!this.form.culturedIslets &&
              !this.form.histoSlides &&
              !this.form.frozenIslets &&
              !this.form.acinar &&
              !this.form.ancillary &&
              !this.form.bloodProd) ||
            (this.form.culturedIslets &&
              (this.form.ieQs_Ideal === undefined ||
                this.form.ieQs_Ideal === '' ||
                this.form.ieQs_Min === undefined ||
                this.form.ieQs_Min === '' ||
                this.form.purity_Ideal === undefined ||
                this.form.purity_Ideal === '' ||
                this.form.purity_Min === undefined ||
                this.form.purity_Min === '' ||
                this.form.viability_Ideal === undefined ||
                this.form.viability_Ideal === '' ||
                this.form.viability_Min === undefined ||
                this.form.viability_Min === '' ||
                this.form.freq_Ideal === undefined ||
                this.form.freq_Ideal === '' ||
                this.form.freq_Min === undefined ||
                this.form.freq_Min === '' ||
                this.form.tot_IEQs_Needed === undefined ||
                this.form.tot_IEQs_Needed === '' ||
                (this.userInfo.study.form.pilot &&
                  this.form.tot_IEQs_Needed > 100000) ||
                this.form.cultured_Ideal === undefined ||
                this.form.cultured_Ideal === '' ||
                this.form.cultured_Min === undefined ||
                this.form.cultured_Min === '' ||
                this.form.diabetic_Ideal === undefined ||
                this.form.diabetic_Ideal === '' ||
                this.form.diabetic_Min === undefined ||
                this.form.diabetic_Min === '' ||
                this.form.diabetic_Ideal === undefined ||
                this.form.diabetic_Ideal === '')) ||
            (!this.form.cellDeath &&
              !this.form.cellStimulus &&
              !this.form.type1Diabetes &&
              !this.form.tissueEngineering &&
              !this.form.alphaCells &&
              !this.form.geneticsGenomics &&
              !this.form.otherArea) ||
            (this.form.otherArea &&
              (!this.form.otherAreaText ||
                this.form.otherAreaText.trim().length < 2)) ||
            this.form.referrals === undefined ||
            this.form.referrals === null ||
            this.form.referrals.length < 1 ||
            ((this.form.referrals !== null ||
              this.form.referrals !== undefined) &&
              this.form.referrals.length > 0 &&
              this.form.referrals.indexOf(-9) !== -1 &&
              (this.form.referralOther === '' ||
                this.form.referralOther === undefined ||
                this.form.referralOther === null)) ||
            (this.form.referrals.indexOf(4) !== -1 &&
              (this.form.meeting === 0 ||
                this.form.meeting === undefined ||
                this.form.meeting === null ||
                this.form.meeting === 'null')) ||
            (this.form.cultureLen &&
              ((isNaN(parseInt(this.form.cultureMinDay, 10))
                ? 0
                : 24 * parseInt(this.form.cultureMinDay, 10)) +
                (isNaN(parseInt(this.form.cultureMinHr, 10))
                  ? 0
                  : parseInt(this.form.cultureMinHr, 10)) >
                (isNaN(parseInt(this.form.cultureMaxDay, 10))
                  ? 0
                  : 24 * parseInt(this.form.cultureMaxDay, 10)) +
                  (isNaN(parseInt(this.form.cultureMaxHr, 10))
                    ? 0
                    : parseInt(this.form.cultureMaxHr, 10)) ||
                (isNaN(parseInt(this.form.cultureMinDay, 10))
                  ? 0
                  : 24 * parseInt(this.form.cultureMinDay, 10)) +
                  (isNaN(parseInt(this.form.cultureMinHr, 10))
                    ? 0
                    : parseInt(this.form.cultureMinHr, 10)) ===
                  0 ||
                (isNaN(parseInt(this.form.cultureMaxDay, 10))
                  ? 0
                  : 24 * parseInt(this.form.cultureMaxDay, 10)) +
                  (isNaN(parseInt(this.form.cultureMaxHr, 10))
                    ? 0
                    : parseInt(this.form.cultureMaxHr, 10)) ===
                  0)) ||
            (this.form.bloodProd && !this.form.serum && !this.form.plasma) ||
            (this.form.ancillary &&
              !this.form.spleen &&
              !this.form.duodenum &&
              !this.form.lymphNode &&
              !this.form.frozenPancreaticPcs) ||
            this.form.animalResearch === null ||
            (this.form.animalResearch &&
              (this.form.iacuC_Status === null ||
                this.form.iacuC_Status === '' ||
                this.form.iacuC_Status === undefined)) ||
            (this.form.iacuC_Status === 1 &&
              (this.form.iacuC_App_No === null ||
                this.form.iacuC_App_No === '' ||
                this.form.iacuC_App_Dt === null)) ||
            (this.form.culturedIslets &&
              !this.form.peer_Rev_Grant &&
              (!this.form.isletsReqReason ||
                this.form.isletsReqReason.trim().length < 2)) ||
            (this.form.frozenIslets &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleFrozen ||
                this.form.rationaleFrozen.trim().length < 2)) ||
            (this.form.histoSlides &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleHistoSlides ||
                this.form.rationaleHistoSlides.trim().length < 2)) ||
            (this.form.acinar &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleAcinar ||
                this.form.rationaleAcinar.trim().length < 2)) ||
            (this.form.ancillary &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleAncillary ||
                this.form.rationaleAncillary.trim().length < 2)) ||
            (this.form.bloodProd &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleBlood ||
                this.form.rationaleBlood.trim().length < 2))
          ) {
            this.menuItems[2].isValid = false;
            this.hasStudyDetailsComplete = false;
          } else {
            this.hasStudyDetailsComplete = true;
            this.menuItems[2].isValid = true;
          }
          this.processStepProgress();
        }
        if (stepData.id === 4) {
          this.processStepProgress();
        }
        this.grantList = stepData.grantList;
      } else {
        if (stepData.id === 1) {
          if (
            !this.form.firstName ||
            this.form.firstName.trim().length < 2 ||
            !this.form.lastName ||
            this.form.lastName.trim().length < 2 ||
            this.form.pI_Email === null ||
            this.form.pI_Email === '' ||
            this.form.pI_Email === undefined ||
            !this.form.institution ||
            this.form.institution.trim().length < 2 ||
            !this.form.title ||
            this.form.title.trim().length < 2 ||
            !this.form.pI_Address_1 ||
            this.form.pI_Address_1.trim().length < 2 ||
            !this.form.pI_City ||
            this.form.pI_City.trim().length < 2 ||
            !this.form.pI_Zip ||
            this.form.pI_Zip.trim().length < 2 ||
            (this.form.country === 'United States' &&
              (this.form.pI_State === '' ||
                this.form.pI_State === null ||
                this.form.pI_State === undefined)) ||
            ((this.form.country === 'Germany' ||
              this.form.country === 'Australia' ||
              this.form.country === 'Israel') &&
              (this.form.pI_State_Oth === null ||
                this.form.pI_State_Oth === '' ||
                this.form.pI_State_Oth === undefined)) ||
            (this.form.country === 'Canada' &&
              (this.form.pI_Province === null ||
                this.form.pI_Province === '' ||
                this.form.pI_Province === undefined)) ||
            this.form.country === null ||
            this.form.country === '' ||
            this.form.country === undefined ||
            this.form.pI_Phone === null ||
            this.form.pI_Phone === '' ||
            this.form.pI_Phone === '(111) 111-1111' ||
            this.form.pI_Phone === undefined ||
            this.form.time_Zone === null ||
            this.form.time_Zone === '' ||
            this.form.time_Zone === undefined ||
            (this.form.wKShipment &&
              (this.form.wkShipCountry === '' ||
                this.form.wkShipCountry === null ||
                !this.form.wK_Ship_Addr_1 ||
                this.form.wK_Ship_Addr_1.trim().length < 2 ||
                !this.form.wK_Ship_City ||
                this.form.wK_Ship_City.trim().length < 2 ||
                !this.form.wK_Ship_Zip ||
                this.form.wK_Ship_Zip.trim().length < 2 ||
                (this.form.wkShipCountry === 'United States' &&
                  (this.form.wK_Ship_State === '' ||
                    this.form.wK_Ship_State === null ||
                    this.form.wK_Ship_State === undefined)) ||
                ((this.form.wkShipCountry === 'Germany' ||
                  this.form.wkShipCountry === 'Australia' ||
                  this.form.wkShipCountry === 'Israel') &&
                  (this.form.wK_Ship_State_Oth === null ||
                    this.form.wK_Ship_State_Oth === '' ||
                    this.form.wK_Ship_State_Oth === undefined)) ||
                (this.form.wkShipCountry === 'Canada' &&
                  (this.form.wK_Ship_Province === null ||
                    this.form.wK_Ship_Province === '' ||
                    this.form.wK_Ship_Province === undefined)))) ||
            this.form.shipCountry === '' ||
            this.form.shipCountry === null ||
            this.form.ship_Addr_1 === '' ||
            this.form.ship_Addr_1 === null ||
            this.form.ship_City === '' ||
            this.form.ship_City === null ||
            this.form.ship_Zip === '' ||
            this.form.ship_Zip === null ||
            (this.form.shipCountry === 'United States' &&
              (this.form.ship_State === '' ||
                this.form.ship_State === null ||
                this.form.ship_State === undefined)) ||
            ((this.form.shipCountry === 'Germany' ||
              this.form.shipCountry === 'Australia' ||
              this.form.shipCountry === 'Israel') &&
              (this.form.ship_State_Oth === null ||
                this.form.ship_State_Oth === '' ||
                this.form.ship_State_Oth === undefined)) ||
            (this.form.shipCountry === 'Canada' &&
              (this.form.ship_Province === null ||
                this.form.ship_Province === '' ||
                this.form.ship_Province === undefined)) ||
            this.form.degrees.length < 1 ||
            (this.form.degrees.length > 0 &&
              this.form.degrees.indexOf(-9) !== -1 &&
              (this.form.degreeOther === '' ||
                this.form.degreeOther === undefined)) ||
            (!this.form.hasORCID && this.form.rsnNoORCID === null) ||
            this.form.rsnNoORCID === '' ||
            (this.form.hasORCID && this.form.orcid === null) ||
            this.form.orcid === '' ||
            (this.form.hasORCID &&
              this.form.orcid !== null &&
              this.form.orcid.indexOf('_') !== -1) ||
            (this.form.textMsg &&
              (this.form.pI_Cell === null || this.form.provider_ID === null)) ||
            (this.form.textMsg &&
              this.form.pI_Cell !== null &&
              !this.form.pI_Cell.match(validationRegex)) ||
            (this.form.pI_Phone !== null &&
              !this.form.pI_Phone.match(validationRegex)) ||
            (this.form.pI_Phone !== null &&
              !this.form.pI_Phone.match(validationRegex)) ||
            (this.form.wK_Phone !== null &&
              !this.form.wK_Phone.match(validationRegex))
          ) {
            this.menuItems[0].isValid = false;
            this.hasContactComplete = false;
          } else {
            this.menuItems[0].isValid = true;
            this.hasContactComplete = true;
            if (
              this.form.wKShipment &&
              (this.form.wkShipCountry === '' ||
                this.form.wkShipCountry === null ||
                !this.form.wK_Ship_Addr_1 ||
                this.form.wK_Ship_Addr_1.trim().length < 2 ||
                !this.form.wK_Ship_City ||
                this.form.wK_Ship_City.trim().length < 2 ||
                !this.form.wK_Ship_Zip ||
                this.form.wK_Ship_Zip.trim().length < 2 ||
                (this.form.wkShipCountry === 'United States' &&
                  (this.form.wK_Ship_State === '' ||
                    this.form.wK_Ship_State === null ||
                    this.form.wK_Ship_State === undefined)) ||
                ((this.form.wkShipCountry === 'Germany' ||
                  this.form.wkShipCountry === 'Australia' ||
                  this.form.wkShipCountry === 'Israel') &&
                  (this.form.wK_Ship_State_Oth === null ||
                    this.form.wK_Ship_State_Oth === '' ||
                    this.form.wK_Ship_State_Oth === undefined)) ||
                (this.form.wkShipCountry === 'Canada' &&
                  (this.form.wK_Ship_Province === null ||
                    this.form.wK_Ship_Province === '' ||
                    this.form.wK_Ship_Province === undefined)))
            ) {
              this.menuItems[0].isValid = false;
              this.hasContactComplete = false;
            }
            if (
              this.form.shipCountry === '' ||
              this.form.shipCountry === null ||
              !this.form.ship_Addr_1 ||
              this.form.ship_Addr_1.trim().length < 2 ||
              !this.form.ship_City ||
              this.form.ship_City.trim().length < 2 ||
              !this.form.ship_Zip ||
              this.form.ship_Zip.trim().length < 2 ||
              (this.form.shipCountry === 'United States' &&
                (this.form.ship_State === '' ||
                  this.form.ship_State === null ||
                  this.form.ship_State === undefined)) ||
              ((this.form.shipCountry === 'Germany' ||
                this.form.shipCountry === 'Australia' ||
                this.form.shipCountry === 'Israel') &&
                (this.form.ship_State_Oth === null ||
                  this.form.ship_State_Oth === '' ||
                  this.form.ship_State_Oth === undefined)) ||
              (this.form.shipCountry === 'Canada' &&
                (this.form.ship_Province === null ||
                  this.form.ship_Province === '' ||
                  this.form.ship_Province === undefined))
            ) {
              this.menuItems[0].isValid = false;
              this.hasContactComplete = false;
            }
            if (
              this.form.country !== '' &&
              this.form.country === 'United States' &&
              this.form.country === 'Canada' &&
              this.form.pI_Phone !== null &&
              !this.form.pI_Phone.match(validationRegex)
            ) {
              this.hasContactComplete = false;
              this.menuItems[0].isValid = false;
            }
            if (
              this.form.country !== '' &&
              this.form.country !== 'United States' &&
              this.form.country !== 'Canada' &&
              this.form.pI_Phone === null
            ) {
              this.hasContactComplete = false;
              this.menuItems[0].isValid = false;
            }
          }
          this.processStepProgress();
        }
        if (stepData.id === 2) {
          if (
            (this.form.peer_Rev_Grant ||
              this.form.fundsAva ||
              this.form.non_Profit) &&
            (this.userInfo.study.grantList.length >= 1 || this.hasFunding)
          ) {
            this.menuItems[1].isValid = true;
          } else {
            this.menuItems[1].isValid = false;
          }

          this.processStepProgress();
        }
        if (stepData.id === 3) {
          if (
            !this.form.study_Title ||
            this.form.study_Title.trim().length < 2 ||
            !this.form.projAbstract ||
            this.form.projAbstract.trim().length < 2 ||
            !this.form.researchMethods ||
            this.form.researchMethods.trim().length < 2 ||
            this.form.comp_Dt === null ||
            this.form.comp_Dt === undefined ||
            this.form.comp_Dt === '' ||
            (!this.form.culturedIslets &&
              !this.form.histoSlides &&
              !this.form.frozenIslets &&
              !this.form.acinar &&
              !this.form.ancillary &&
              !this.form.bloodProd) ||
            (this.form.culturedIslets &&
              (this.form.ieQs_Ideal === undefined ||
                this.form.ieQs_Ideal === '' ||
                this.form.ieQs_Min === undefined ||
                this.form.ieQs_Min === '' ||
                this.form.purity_Ideal === undefined ||
                this.form.purity_Ideal === '' ||
                this.form.purity_Min === undefined ||
                this.form.purity_Min === '' ||
                this.form.viability_Ideal === undefined ||
                this.form.viability_Ideal === '' ||
                this.form.viability_Min === undefined ||
                this.form.viability_Min === '' ||
                this.form.freq_Ideal === undefined ||
                this.form.freq_Ideal === '' ||
                this.form.freq_Min === undefined ||
                this.form.freq_Min === '' ||
                this.form.tot_IEQs_Needed === undefined ||
                this.form.tot_IEQs_Needed === '' ||
                (this.userInfo.study.form.pilot &&
                  this.form.tot_IEQs_Needed > 100000) ||
                this.form.cultured_Ideal === undefined ||
                this.form.cultured_Ideal === '' ||
                this.form.cultured_Min === undefined ||
                this.form.cultured_Min === '' ||
                this.form.diabetic_Ideal === undefined ||
                this.form.diabetic_Ideal === '' ||
                this.form.diabetic_Min === undefined ||
                this.form.diabetic_Min === '' ||
                this.form.diabetic_Ideal === undefined ||
                this.form.diabetic_Ideal === '')) ||
            (!this.form.cellDeath &&
              !this.form.cellStimulus &&
              !this.form.type1Diabetes &&
              !this.form.tissueEngineering &&
              !this.form.alphaCells &&
              !this.form.geneticsGenomics &&
              !this.form.otherArea) ||
            (this.form.otherArea &&
              (!this.form.otherAreaText ||
                this.form.otherAreaText.trim().length < 2)) ||
            (this.form.cultureLen &&
              ((isNaN(parseInt(this.form.cultureMinDay, 10))
                ? 0
                : 24 * parseInt(this.form.cultureMinDay, 10)) +
                (isNaN(parseInt(this.form.cultureMinHr, 10))
                  ? 0
                  : parseInt(this.form.cultureMinHr, 10)) >
                (isNaN(parseInt(this.form.cultureMaxDay, 10))
                  ? 0
                  : 24 * parseInt(this.form.cultureMaxDay, 10)) +
                  (isNaN(parseInt(this.form.cultureMaxHr, 10))
                    ? 0
                    : parseInt(this.form.cultureMaxHr, 10)) ||
                (isNaN(parseInt(this.form.cultureMinDay, 10))
                  ? 0
                  : 24 * parseInt(this.form.cultureMinDay, 10)) +
                  (isNaN(parseInt(this.form.cultureMinHr, 10))
                    ? 0
                    : parseInt(this.form.cultureMinHr, 10)) ===
                  0 ||
                (isNaN(parseInt(this.form.cultureMaxDay, 10))
                  ? 0
                  : 24 * parseInt(this.form.cultureMaxDay, 10)) +
                  (isNaN(parseInt(this.form.cultureMaxHr, 10))
                    ? 0
                    : parseInt(this.form.cultureMaxHr, 10)) ===
                  0)) ||
            (this.form.bloodProd && !this.form.serum && !this.form.plasma) ||
            (this.form.ancillary &&
              !this.form.spleen &&
              !this.form.duodenum &&
              !this.form.lymphNode &&
              !this.form.frozenPancreaticPcs) ||
            this.form.animalResearch === null ||
            (this.form.animalResearch &&
              (this.form.iacuC_Status === null ||
                this.form.iacuC_Status === '' ||
                this.form.iacuC_Status === undefined)) ||
            (this.form.iacuC_Status === 1 &&
              (this.form.iacuC_App_No === null ||
                this.form.iacuC_App_No === '' ||
                this.form.iacuC_App_Dt === null)) ||
            (this.form.culturedIslets &&
              !this.form.peer_Rev_Grant &&
              (!this.form.isletsReqReason ||
                this.form.isletsReqReason.trim().length < 2)) ||
            (this.form.frozenIslets &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleFrozen ||
                this.form.rationaleFrozen.trim().length < 2)) ||
            (this.form.histoSlides &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleHistoSlides ||
                this.form.rationaleHistoSlides.trim().length < 2)) ||
            (this.form.acinar &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleAcinar ||
                this.form.rationaleAcinar.trim().length < 2)) ||
            (this.form.ancillary &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleAncillary ||
                this.form.rationaleAncillary.trim().length < 2)) ||
            (this.form.bloodProd &&
              !this.form.peer_Rev_Grant &&
              (!this.form.rationaleBlood ||
                this.form.rationaleBlood.trim().length < 2))
          ) {
            this.menuItems[2].isValid = false;
            this.hasStudyDetailsComplete = false;
          } else {
            this.hasStudyDetailsComplete = true;
            this.menuItems[2].isValid = true;
          }
          this.processStepProgress();
        }
        if (stepData.id === 4) {
          this.processStepProgress();
        }
      }
    }, 1000);
  }
}
